(function(global, factory) {
    typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require("react"), require("@apollo/client"), require("axios"), require("graphql")) : typeof define === "function" && define.amd ? define([ "exports", "react", "@apollo/client", "axios", "graphql" ], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, 
    factory(global.BloomreachConnectorComponentsReact = {}, global.React, global.ApolloClient, global.axios));
})(this, (function(exports, React, client, axios) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    }
    var React__default = _interopDefaultLegacy(React);
    var axios__default = _interopDefaultLegacy(axios);
    const loggedInVar = client.makeVar(false);
    const tokenVar = client.makeVar(undefined);
    function extractErrorMessage(error) {
        var _a, _b, _c, _d, _e;
        if ("isAxiosError" in error && error.isAxiosError) {
            return (_e = (_d = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : error.message;
        }
        return error.message;
    }
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __);
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
        }
        return t;
    }
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P((function(resolve) {
                resolve(value);
            }));
        }
        return new (P || (P = Promise))((function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        }));
    }
    const tokenCache = new Map;
    function retryAdapterEnhancer(adapter) {
        return config => (() => __awaiter(this, void 0, void 0, (function*() {
            var _a, _b, _c, _d;
            try {
                return yield adapter(config);
            } catch (err) {
                let data;
                try {
                    data = JSON.parse((_a = err.response) === null || _a === void 0 ? void 0 : _a.data);
                } catch (_e) {}
                if (((_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.extensions) === null || _d === void 0 ? void 0 : _d.code) === "TOKEN_INVALID") {
                    delete config.headers.authorization;
                    return adapter(config);
                }
                throw err;
            }
        })))();
    }
    function buildApolloError(error) {
        var _a, _b, _c;
        const error0 = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0];
        if (error0) {
            return new client.ApolloError({
                errorMessage: error0.message,
                extraInfo: error0.extensions
            });
        }
        return new client.ApolloError({
            errorMessage: error.message
        });
    }
    const axiosInstance = axios__default["default"].create({
        adapter: retryAdapterEnhancer(axios__default["default"].defaults.adapter)
    });
    axiosInstance.interceptors.response.use(response => response, error => Promise.reject(error.isAxiosError ? buildApolloError(error) : error));
    function buildCacheIndex(data, headers) {
        return `${JSON.stringify(data)}:${JSON.stringify(headers)}`;
    }
    function getTokenFromCache(cacheIndex) {
        if (tokenCache.has(cacheIndex)) {
            const cachedToken = tokenCache.get(cacheIndex);
            if (cachedToken) {
                return cachedToken;
            }
        } else {
            tokenCache.clear();
        }
        return undefined;
    }
    class AuthService {
        login(credentials, graphqlServiceUrl, connector, previousToken) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, (function*() {
                const config = {};
                if (previousToken) {
                    config.headers = {
                        authorization: `Bearer ${previousToken}`
                    };
                }
                config.headers = Object.assign(Object.assign({}, config.headers), {
                    connector
                });
                let res;
                const cacheIndex = buildCacheIndex(credentials, config.headers);
                const cachedTokenRequest = getTokenFromCache(cacheIndex);
                if (cachedTokenRequest) {
                    res = yield cachedTokenRequest;
                } else {
                    const signInRequest = axiosInstance.post(`${graphqlServiceUrl}/signin`, credentials, config);
                    tokenCache.set(cacheIndex, signInRequest);
                    try {
                        res = yield signInRequest;
                    } finally {
                        tokenCache.clear();
                    }
                }
                if (res.status === 200 && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.authorization)) {
                    const token = res.data.authorization;
                    tokenVar(token);
                    return {
                        token
                    };
                }
                throw new Error(`Something went wrong during login operation: ${(_d = (_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.message}`);
            }));
        }
        refresh(previousToken, graphqlServiceUrl, connector, credentials) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, (function*() {
                const data = Object.assign({
                    type: "refresh"
                }, credentials);
                const config = {};
                config.headers = {
                    connector,
                    authorization: `Bearer ${previousToken}`
                };
                let res;
                const cacheIndex = buildCacheIndex(data, config.headers);
                const cachedTokenRefreshRequest = getTokenFromCache(cacheIndex);
                if (cachedTokenRefreshRequest) {
                    res = yield cachedTokenRefreshRequest;
                } else {
                    const tokenRefreshRequest = axiosInstance.post(`${graphqlServiceUrl}/signin`, data, config);
                    tokenCache.set(cacheIndex, tokenRefreshRequest);
                    try {
                        res = yield tokenRefreshRequest;
                    } finally {
                        tokenCache.clear();
                    }
                }
                if (res.status === 200 && res.data.authorization) {
                    const token = res.data.authorization;
                    tokenVar(token);
                    return {
                        token
                    };
                }
                throw new Error(`Something went wrong during refresh operation: ${(_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message}`);
            }));
        }
        logout() {
            tokenVar(undefined);
            loggedInVar(false);
        }
    }
    const auth = new AuthService;
    (function(Object) {
        typeof globalThis !== "object" && (this ? get() : (Object.defineProperty(Object.prototype, "_T_", {
            configurable: true,
            get
        }), _T_));
        function get() {
            var global = this || self;
            global.globalThis = global;
            delete Object.prototype._T_;
        }
    })(Object);
    var globalThis$1 = globalThis;
    var genericMessage = "Invariant Violation";
    var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function(obj, proto) {
        obj.__proto__ = proto;
        return obj;
    } : _a;
    var InvariantError = /** @class */ function(_super) {
        __extends(InvariantError, _super);
        function InvariantError(message) {
            if (message === void 0) {
                message = genericMessage;
            }
            var _this = _super.call(this, typeof message === "number" ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
            _this.framesToPop = 1;
            _this.name = genericMessage;
            setPrototypeOf(_this, InvariantError.prototype);
            return _this;
        }
        return InvariantError;
    }(Error);
    function invariant(condition, message) {
        if (!condition) {
            throw new InvariantError(message);
        }
    }
    var verbosityLevels = [ "log", "warn", "error", "silent" ];
    var verbosityLevel = verbosityLevels.indexOf("log");
    function wrapConsoleMethod(method) {
        return function() {
            if (verbosityLevels.indexOf(method) >= verbosityLevel) {
                return console[method].apply(console, arguments);
            }
        };
    }
    (function(invariant) {
        invariant.log = wrapConsoleMethod("log");
        invariant.warn = wrapConsoleMethod("warn");
        invariant.error = wrapConsoleMethod("error");
    })(invariant || (invariant = {}));
    var processStub = globalThis$1.process || {
        env: {}
    };
    if (!globalThis$1.process) try {
        Object.defineProperty(globalThis$1, "process", {
            value: processStub
        });
    } catch (_b) {}
    function getOperationName(doc) {
        return doc.definitions.filter((function(definition) {
            return definition.kind === "OperationDefinition" && definition.name;
        })).map((function(x) {
            return x.name.value;
        }))[0] || null;
    }
    function createCommonjsModule(fn, basedir, module) {
        return module = {
            path: basedir,
            exports: {},
            require: function(path, base) {
                return commonjsRequire(path, base === undefined || base === null ? module.path : base);
            }
        }, fn(module, module.exports), module.exports;
    }
    function commonjsRequire() {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
    }
    var Observable_1 = createCommonjsModule((function(module, exports) {
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.Observable = void 0;
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
        }
        var hasSymbols = function() {
            return typeof Symbol === "function";
        };
        var hasSymbol = function(name) {
            return hasSymbols() && Boolean(Symbol[name]);
        };
        var getSymbol = function(name) {
            return hasSymbol(name) ? Symbol[name] : "@@" + name;
        };
        if (hasSymbols() && !hasSymbol("observable")) {
            Symbol.observable = Symbol("observable");
        }
        var SymbolIterator = getSymbol("iterator");
        var SymbolObservable = getSymbol("observable");
        var SymbolSpecies = getSymbol("species");
        function getMethod(obj, key) {
            var value = obj[key];
            if (value == null) return undefined;
            if (typeof value !== "function") throw new TypeError(value + " is not a function");
            return value;
        }
        function getSpecies(obj) {
            var ctor = obj.constructor;
            if (ctor !== undefined) {
                ctor = ctor[SymbolSpecies];
                if (ctor === null) {
                    ctor = undefined;
                }
            }
            return ctor !== undefined ? ctor : Observable;
        }
        function isObservable(x) {
            return x instanceof Observable;
        }
        function hostReportError(e) {
            if (hostReportError.log) {
                hostReportError.log(e);
            } else {
                setTimeout((function() {
                    throw e;
                }));
            }
        }
        function enqueue(fn) {
            Promise.resolve().then((function() {
                try {
                    fn();
                } catch (e) {
                    hostReportError(e);
                }
            }));
        }
        function cleanupSubscription(subscription) {
            var cleanup = subscription._cleanup;
            if (cleanup === undefined) return;
            subscription._cleanup = undefined;
            if (!cleanup) {
                return;
            }
            try {
                if (typeof cleanup === "function") {
                    cleanup();
                } else {
                    var unsubscribe = getMethod(cleanup, "unsubscribe");
                    if (unsubscribe) {
                        unsubscribe.call(cleanup);
                    }
                }
            } catch (e) {
                hostReportError(e);
            }
        }
        function closeSubscription(subscription) {
            subscription._observer = undefined;
            subscription._queue = undefined;
            subscription._state = "closed";
        }
        function flushSubscription(subscription) {
            var queue = subscription._queue;
            if (!queue) {
                return;
            }
            subscription._queue = undefined;
            subscription._state = "ready";
            for (var i = 0; i < queue.length; ++i) {
                notifySubscription(subscription, queue[i].type, queue[i].value);
                if (subscription._state === "closed") break;
            }
        }
        function notifySubscription(subscription, type, value) {
            subscription._state = "running";
            var observer = subscription._observer;
            try {
                var m = getMethod(observer, type);
                switch (type) {
                  case "next":
                    if (m) m.call(observer, value);
                    break;

                  case "error":
                    closeSubscription(subscription);
                    if (m) m.call(observer, value); else throw value;
                    break;

                  case "complete":
                    closeSubscription(subscription);
                    if (m) m.call(observer);
                    break;
                }
            } catch (e) {
                hostReportError(e);
            }
            if (subscription._state === "closed") cleanupSubscription(subscription); else if (subscription._state === "running") subscription._state = "ready";
        }
        function onNotify(subscription, type, value) {
            if (subscription._state === "closed") return;
            if (subscription._state === "buffering") {
                subscription._queue.push({
                    type,
                    value
                });
                return;
            }
            if (subscription._state !== "ready") {
                subscription._state = "buffering";
                subscription._queue = [ {
                    type,
                    value
                } ];
                enqueue((function() {
                    return flushSubscription(subscription);
                }));
                return;
            }
            notifySubscription(subscription, type, value);
        }
        var Subscription = function() {
            function Subscription(observer, subscriber) {
                _classCallCheck(this, Subscription);
                this._cleanup = undefined;
                this._observer = observer;
                this._queue = undefined;
                this._state = "initializing";
                var subscriptionObserver = new SubscriptionObserver(this);
                try {
                    this._cleanup = subscriber.call(undefined, subscriptionObserver);
                } catch (e) {
                    subscriptionObserver.error(e);
                }
                if (this._state === "initializing") this._state = "ready";
            }
            _createClass(Subscription, [ {
                key: "unsubscribe",
                value: function unsubscribe() {
                    if (this._state !== "closed") {
                        closeSubscription(this);
                        cleanupSubscription(this);
                    }
                }
            }, {
                key: "closed",
                get: function() {
                    return this._state === "closed";
                }
            } ]);
            return Subscription;
        }();
        var SubscriptionObserver = function() {
            function SubscriptionObserver(subscription) {
                _classCallCheck(this, SubscriptionObserver);
                this._subscription = subscription;
            }
            _createClass(SubscriptionObserver, [ {
                key: "next",
                value: function next(value) {
                    onNotify(this._subscription, "next", value);
                }
            }, {
                key: "error",
                value: function error(value) {
                    onNotify(this._subscription, "error", value);
                }
            }, {
                key: "complete",
                value: function complete() {
                    onNotify(this._subscription, "complete");
                }
            }, {
                key: "closed",
                get: function() {
                    return this._subscription._state === "closed";
                }
            } ]);
            return SubscriptionObserver;
        }();
        var Observable = function() {
            function Observable(subscriber) {
                _classCallCheck(this, Observable);
                if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
                if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
                this._subscriber = subscriber;
            }
            _createClass(Observable, [ {
                key: "subscribe",
                value: function subscribe(observer) {
                    if (typeof observer !== "object" || observer === null) {
                        observer = {
                            next: observer,
                            error: arguments[1],
                            complete: arguments[2]
                        };
                    }
                    return new Subscription(observer, this._subscriber);
                }
            }, {
                key: "forEach",
                value: function forEach(fn) {
                    var _this = this;
                    return new Promise((function(resolve, reject) {
                        if (typeof fn !== "function") {
                            reject(new TypeError(fn + " is not a function"));
                            return;
                        }
                        function done() {
                            subscription.unsubscribe();
                            resolve();
                        }
                        var subscription = _this.subscribe({
                            next: function(value) {
                                try {
                                    fn(value, done);
                                } catch (e) {
                                    reject(e);
                                    subscription.unsubscribe();
                                }
                            },
                            error: reject,
                            complete: resolve
                        });
                    }));
                }
            }, {
                key: "map",
                value: function map(fn) {
                    var _this2 = this;
                    if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                    var C = getSpecies(this);
                    return new C((function(observer) {
                        return _this2.subscribe({
                            next: function(value) {
                                try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    }));
                }
            }, {
                key: "filter",
                value: function filter(fn) {
                    var _this3 = this;
                    if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                    var C = getSpecies(this);
                    return new C((function(observer) {
                        return _this3.subscribe({
                            next: function(value) {
                                try {
                                    if (!fn(value)) return;
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    }));
                }
            }, {
                key: "reduce",
                value: function reduce(fn) {
                    var _this4 = this;
                    if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                    var C = getSpecies(this);
                    var hasSeed = arguments.length > 1;
                    var hasValue = false;
                    var seed = arguments[1];
                    var acc = seed;
                    return new C((function(observer) {
                        return _this4.subscribe({
                            next: function(value) {
                                var first = !hasValue;
                                hasValue = true;
                                if (!first || hasSeed) {
                                    try {
                                        acc = fn(acc, value);
                                    } catch (e) {
                                        return observer.error(e);
                                    }
                                } else {
                                    acc = value;
                                }
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                                observer.next(acc);
                                observer.complete();
                            }
                        });
                    }));
                }
            }, {
                key: "concat",
                value: function concat() {
                    var _this5 = this;
                    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
                        sources[_key] = arguments[_key];
                    }
                    var C = getSpecies(this);
                    return new C((function(observer) {
                        var subscription;
                        var index = 0;
                        function startNext(next) {
                            subscription = next.subscribe({
                                next: function(v) {
                                    observer.next(v);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    if (index === sources.length) {
                                        subscription = undefined;
                                        observer.complete();
                                    } else {
                                        startNext(C.from(sources[index++]));
                                    }
                                }
                            });
                        }
                        startNext(_this5);
                        return function() {
                            if (subscription) {
                                subscription.unsubscribe();
                                subscription = undefined;
                            }
                        };
                    }));
                }
            }, {
                key: "flatMap",
                value: function flatMap(fn) {
                    var _this6 = this;
                    if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                    var C = getSpecies(this);
                    return new C((function(observer) {
                        var subscriptions = [];
                        var outer = _this6.subscribe({
                            next: function(value) {
                                if (fn) {
                                    try {
                                        value = fn(value);
                                    } catch (e) {
                                        return observer.error(e);
                                    }
                                }
                                var inner = C.from(value).subscribe({
                                    next: function(value) {
                                        observer.next(value);
                                    },
                                    error: function(e) {
                                        observer.error(e);
                                    },
                                    complete: function() {
                                        var i = subscriptions.indexOf(inner);
                                        if (i >= 0) subscriptions.splice(i, 1);
                                        completeIfDone();
                                    }
                                });
                                subscriptions.push(inner);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                completeIfDone();
                            }
                        });
                        function completeIfDone() {
                            if (outer.closed && subscriptions.length === 0) observer.complete();
                        }
                        return function() {
                            subscriptions.forEach((function(s) {
                                return s.unsubscribe();
                            }));
                            outer.unsubscribe();
                        };
                    }));
                }
            }, {
                key: SymbolObservable,
                value: function() {
                    return this;
                }
            } ], [ {
                key: "from",
                value: function from(x) {
                    var C = typeof this === "function" ? this : Observable;
                    if (x == null) throw new TypeError(x + " is not an object");
                    var method = getMethod(x, SymbolObservable);
                    if (method) {
                        var observable = method.call(x);
                        if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
                        if (isObservable(observable) && observable.constructor === C) return observable;
                        return new C((function(observer) {
                            return observable.subscribe(observer);
                        }));
                    }
                    if (hasSymbol("iterator")) {
                        method = getMethod(x, SymbolIterator);
                        if (method) {
                            return new C((function(observer) {
                                enqueue((function() {
                                    if (observer.closed) return;
                                    var _iteratorNormalCompletion = true;
                                    var _didIteratorError = false;
                                    var _iteratorError = undefined;
                                    try {
                                        for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                            var _item = _step.value;
                                            observer.next(_item);
                                            if (observer.closed) return;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally {
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    observer.complete();
                                }));
                            }));
                        }
                    }
                    if (Array.isArray(x)) {
                        return new C((function(observer) {
                            enqueue((function() {
                                if (observer.closed) return;
                                for (var i = 0; i < x.length; ++i) {
                                    observer.next(x[i]);
                                    if (observer.closed) return;
                                }
                                observer.complete();
                            }));
                        }));
                    }
                    throw new TypeError(x + " is not observable");
                }
            }, {
                key: "of",
                value: function of() {
                    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        items[_key2] = arguments[_key2];
                    }
                    var C = typeof this === "function" ? this : Observable;
                    return new C((function(observer) {
                        enqueue((function() {
                            if (observer.closed) return;
                            for (var i = 0; i < items.length; ++i) {
                                observer.next(items[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        }));
                    }));
                }
            }, {
                key: SymbolSpecies,
                get: function() {
                    return this;
                }
            } ]);
            return Observable;
        }();
        exports.Observable = Observable;
        if (hasSymbols()) {
            Object.defineProperty(Observable, Symbol("extensions"), {
                value: {
                    symbol: SymbolObservable,
                    hostReportError
                },
                configurable: true
            });
        }
    }));
    var zenObservable = Observable_1.Observable;
    function symbolObservablePonyfill(root) {
        var result;
        var Symbol = root.Symbol;
        if (typeof Symbol === "function") {
            if (Symbol.observable) {
                result = Symbol.observable;
            } else {
                result = Symbol.for("https://github.com/benlesh/symbol-observable");
                try {
                    Symbol.observable = result;
                } catch (err) {}
            }
        } else {
            result = "@@observable";
        }
        return result;
    }
    var root;
    if (typeof self !== "undefined") {
        root = self;
    } else if (typeof window !== "undefined") {
        root = window;
    } else if (typeof global !== "undefined") {
        root = global;
    } else if (typeof module !== "undefined") {
        root = module;
    } else {
        root = Function("return this")();
    }
    symbolObservablePonyfill(root);
    zenObservable.prototype["@@observable"] = function() {
        return this;
    };
    function iterateObserversSafely(observers, method, argument) {
        var observersWithMethod = [];
        observers.forEach((function(obs) {
            return obs[method] && observersWithMethod.push(obs);
        }));
        observersWithMethod.forEach((function(obs) {
            return obs[method](argument);
        }));
    }
    function fixObservableSubclass(subclass) {
        function set(key) {
            Object.defineProperty(subclass, key, {
                value: zenObservable
            });
        }
        if (typeof Symbol === "function" && Symbol.species) {
            set(Symbol.species);
        }
        set("@@species");
        return subclass;
    }
    function isPromiseLike(value) {
        return value && typeof value.then === "function";
    }
    var Concast = function(_super) {
        __extends(Concast, _super);
        function Concast(sources) {
            var _this = _super.call(this, (function(observer) {
                _this.addObserver(observer);
                return function() {
                    return _this.removeObserver(observer);
                };
            })) || this;
            _this.observers = new Set;
            _this.addCount = 0;
            _this.promise = new Promise((function(resolve, reject) {
                _this.resolve = resolve;
                _this.reject = reject;
            }));
            _this.handlers = {
                next: function(result) {
                    if (_this.sub !== null) {
                        _this.latest = [ "next", result ];
                        iterateObserversSafely(_this.observers, "next", result);
                    }
                },
                error: function(error) {
                    var sub = _this.sub;
                    if (sub !== null) {
                        if (sub) Promise.resolve().then((function() {
                            return sub.unsubscribe();
                        }));
                        _this.sub = null;
                        _this.latest = [ "error", error ];
                        _this.reject(error);
                        iterateObserversSafely(_this.observers, "error", error);
                    }
                },
                complete: function() {
                    if (_this.sub !== null) {
                        var value = _this.sources.shift();
                        if (!value) {
                            _this.sub = null;
                            if (_this.latest && _this.latest[0] === "next") {
                                _this.resolve(_this.latest[1]);
                            } else {
                                _this.resolve();
                            }
                            iterateObserversSafely(_this.observers, "complete");
                        } else if (isPromiseLike(value)) {
                            value.then((function(obs) {
                                return _this.sub = obs.subscribe(_this.handlers);
                            }));
                        } else {
                            _this.sub = value.subscribe(_this.handlers);
                        }
                    }
                }
            };
            _this.cancel = function(reason) {
                _this.reject(reason);
                _this.sources = [];
                _this.handlers.complete();
            };
            _this.promise.catch((function(_) {}));
            if (typeof sources === "function") {
                sources = [ new zenObservable(sources) ];
            }
            if (isPromiseLike(sources)) {
                sources.then((function(iterable) {
                    return _this.start(iterable);
                }), _this.handlers.error);
            } else {
                _this.start(sources);
            }
            return _this;
        }
        Concast.prototype.start = function(sources) {
            if (this.sub !== void 0) return;
            this.sources = Array.from(sources);
            this.handlers.complete();
        };
        Concast.prototype.deliverLastMessage = function(observer) {
            if (this.latest) {
                var nextOrError = this.latest[0];
                var method = observer[nextOrError];
                if (method) {
                    method.call(observer, this.latest[1]);
                }
                if (this.sub === null && nextOrError === "next" && observer.complete) {
                    observer.complete();
                }
            }
        };
        Concast.prototype.addObserver = function(observer) {
            if (!this.observers.has(observer)) {
                this.deliverLastMessage(observer);
                this.observers.add(observer);
                ++this.addCount;
            }
        };
        Concast.prototype.removeObserver = function(observer, quietly) {
            if (this.observers.delete(observer) && --this.addCount < 1 && !quietly) {
                this.handlers.error(new Error("Observable cancelled prematurely"));
            }
        };
        Concast.prototype.cleanup = function(callback) {
            var _this = this;
            var called = false;
            var once = function() {
                if (!called) {
                    called = true;
                    _this.observers.delete(observer);
                    callback();
                }
            };
            var observer = {
                next: once,
                error: once,
                complete: once
            };
            var count = this.addCount;
            this.addObserver(observer);
            this.addCount = count;
        };
        return Concast;
    }(zenObservable);
    fixObservableSubclass(Concast);
    function validateOperation(operation) {
        var OPERATION_FIELDS = [ "query", "operationName", "variables", "extensions", "context" ];
        for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
            var key = _a[_i];
            if (OPERATION_FIELDS.indexOf(key) < 0) {
                throw process.env.NODE_ENV === "production" ? new InvariantError(26) : new InvariantError("illegal argument: " + key);
            }
        }
        return operation;
    }
    function createOperation(starting, operation) {
        var context = __assign({}, starting);
        var setContext = function(next) {
            if (typeof next === "function") {
                context = __assign(__assign({}, context), next(context));
            } else {
                context = __assign(__assign({}, context), next);
            }
        };
        var getContext = function() {
            return __assign({}, context);
        };
        Object.defineProperty(operation, "setContext", {
            enumerable: false,
            value: setContext
        });
        Object.defineProperty(operation, "getContext", {
            enumerable: false,
            value: getContext
        });
        return operation;
    }
    function transformOperation(operation) {
        var transformedOperation = {
            variables: operation.variables || {},
            extensions: operation.extensions || {},
            operationName: operation.operationName,
            query: operation.query
        };
        if (!transformedOperation.operationName) {
            transformedOperation.operationName = typeof transformedOperation.query !== "string" ? getOperationName(transformedOperation.query) || undefined : "";
        }
        return transformedOperation;
    }
    function passthrough(op, forward) {
        return forward ? forward(op) : zenObservable.of();
    }
    function toLink(handler) {
        return typeof handler === "function" ? new ApolloLink(handler) : handler;
    }
    function isTerminating(link) {
        return link.request.length <= 1;
    }
    var LinkError = function(_super) {
        __extends(LinkError, _super);
        function LinkError(message, link) {
            var _this = _super.call(this, message) || this;
            _this.link = link;
            return _this;
        }
        return LinkError;
    }(Error);
    var ApolloLink = function() {
        function ApolloLink(request) {
            if (request) this.request = request;
        }
        ApolloLink.empty = function() {
            return new ApolloLink((function() {
                return zenObservable.of();
            }));
        };
        ApolloLink.from = function(links) {
            if (links.length === 0) return ApolloLink.empty();
            return links.map(toLink).reduce((function(x, y) {
                return x.concat(y);
            }));
        };
        ApolloLink.split = function(test, left, right) {
            var leftLink = toLink(left);
            var rightLink = toLink(right || new ApolloLink(passthrough));
            if (isTerminating(leftLink) && isTerminating(rightLink)) {
                return new ApolloLink((function(operation) {
                    return test(operation) ? leftLink.request(operation) || zenObservable.of() : rightLink.request(operation) || zenObservable.of();
                }));
            } else {
                return new ApolloLink((function(operation, forward) {
                    return test(operation) ? leftLink.request(operation, forward) || zenObservable.of() : rightLink.request(operation, forward) || zenObservable.of();
                }));
            }
        };
        ApolloLink.execute = function(link, operation) {
            return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || zenObservable.of();
        };
        ApolloLink.concat = function(first, second) {
            var firstLink = toLink(first);
            if (isTerminating(firstLink)) {
                process.env.NODE_ENV === "production" || invariant.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
                return firstLink;
            }
            var nextLink = toLink(second);
            if (isTerminating(nextLink)) {
                return new ApolloLink((function(operation) {
                    return firstLink.request(operation, (function(op) {
                        return nextLink.request(op) || zenObservable.of();
                    })) || zenObservable.of();
                }));
            } else {
                return new ApolloLink((function(operation, forward) {
                    return firstLink.request(operation, (function(op) {
                        return nextLink.request(op, forward) || zenObservable.of();
                    })) || zenObservable.of();
                }));
            }
        };
        ApolloLink.prototype.split = function(test, left, right) {
            return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
        };
        ApolloLink.prototype.concat = function(next) {
            return ApolloLink.concat(this, next);
        };
        ApolloLink.prototype.request = function(operation, forward) {
            throw process.env.NODE_ENV === "production" ? new InvariantError(21) : new InvariantError("request is not implemented");
        };
        ApolloLink.prototype.onError = function(error, observer) {
            if (observer && observer.error) {
                observer.error(error);
                return false;
            }
            throw error;
        };
        ApolloLink.prototype.setOnError = function(fn) {
            this.onError = fn;
            return this;
        };
        return ApolloLink;
    }();
    function onError(errorHandler) {
        return new ApolloLink((function(operation, forward) {
            return new zenObservable((function(observer) {
                var sub;
                var retriedSub;
                var retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: function(result) {
                            if (result.errors) {
                                retriedResult = errorHandler({
                                    graphQLErrors: result.errors,
                                    response: result,
                                    operation,
                                    forward
                                });
                                if (retriedResult) {
                                    retriedSub = retriedResult.subscribe({
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    });
                                    return;
                                }
                            }
                            observer.next(result);
                        },
                        error: function(networkError) {
                            retriedResult = errorHandler({
                                operation,
                                networkError,
                                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                                forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                            observer.error(networkError);
                        },
                        complete: function() {
                            if (!retriedResult) {
                                observer.complete.bind(observer)();
                            }
                        }
                    });
                } catch (e) {
                    errorHandler({
                        networkError: e,
                        operation,
                        forward
                    });
                    observer.error(e);
                }
                return function() {
                    if (sub) sub.unsubscribe();
                    if (retriedSub) sub.unsubscribe();
                };
            }));
        }));
    }
    (function(_super) {
        __extends(ErrorLink, _super);
        function ErrorLink(errorHandler) {
            var _this = _super.call(this) || this;
            _this.link = onError(errorHandler);
            return _this;
        }
        ErrorLink.prototype.request = function(operation, forward) {
            return this.link.request(operation, forward);
        };
        return ErrorLink;
    })(ApolloLink);
    var MutationResponse = [ "AddressMutationResponse", "CartMutationResponse", "CustomerAuthMutationResponse", "OrderMutationResponse" ];
    var ItemLike = [ "Item", "ItemVariant" ];
    var PageResult = [ "ItemsPageResult", "OrdersPageResult" ];
    var possibleTypes = {
        MutationResponse,
        ItemLike,
        PageResult
    };
    const DEFAULT_REQUEST_HEADERS = {
        "Accept-Language": ""
    };
    const DEFAULT_ANONYMOUS_CREDENTIALS = {
        scope: "public"
    };
    class CommerceApiClientFactory {
        constructor(graphqlServiceUrl, connector, defaultRequestHeaders, defaultAnonymousCredentials) {
            this.graphqlServiceUrl = graphqlServiceUrl;
            this.connector = connector;
            this.defaultRequestHeaders = defaultRequestHeaders;
            this.defaultAnonymousCredentials = defaultAnonymousCredentials;
        }
        createClient() {
            const customFetch = (uri, options) => __awaiter(this, void 0, void 0, (function*() {
                var _a, _b, _c, _d, _e;
                let headers = Object.assign(Object.assign({}, (_a = this.defaultRequestHeaders) !== null && _a !== void 0 ? _a : DEFAULT_REQUEST_HEADERS), (_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : {});
                const connector = "connector" in headers ? headers.connector : this.connector;
                const defaultAttrs = {
                    referer: window.location.href
                };
                let token = tokenVar();
                if (!token) {
                    const result = yield auth.login((_c = this.defaultAnonymousCredentials) !== null && _c !== void 0 ? _c : Object.assign(Object.assign({}, DEFAULT_ANONYMOUS_CREDENTIALS), {
                        attrs: defaultAttrs
                    }), this.graphqlServiceUrl, connector);
                    token = result.token;
                    options.headers = Object.assign(Object.assign({}, headers), {
                        connector,
                        authorization: `Bearer ${token}`
                    });
                    return fetch(uri, options);
                }
                options.headers = Object.assign(Object.assign({}, headers), {
                    connector,
                    authorization: `Bearer ${token}`
                });
                headers = options.headers;
                if ("forceRefresh" in headers) {
                    const {forceRefresh} = headers;
                    if (!forceRefresh) {
                        return fetch(uri, options);
                    }
                    const previousToken = headers.authorization;
                    const includeAuthorization = (_d = headers.includeAuthorization) !== null && _d !== void 0 ? _d : true;
                    let res;
                    if (includeAuthorization) {
                        try {
                            res = yield auth.refresh(previousToken, this.graphqlServiceUrl, connector);
                        } catch (error) {
                            if (error.extraInfo.code !== "FORBIDDEN") {
                                throw error;
                            }
                        }
                    }
                    if (!res) {
                        res = yield auth.login((_e = this.defaultAnonymousCredentials) !== null && _e !== void 0 ? _e : Object.assign(Object.assign({}, DEFAULT_ANONYMOUS_CREDENTIALS), {
                            attrs: defaultAttrs
                        }), this.graphqlServiceUrl, connector);
                    }
                    token = res.token;
                    options.headers = Object.assign(Object.assign({}, headers), {
                        authorization: `Bearer ${token}`
                    });
                }
                return fetch(uri, options);
            }));
            const httpLink = client.createHttpLink({
                uri: `${this.graphqlServiceUrl}/graphql`,
                fetch: customFetch
            });
            const errorHandlerLink = onError(({graphQLErrors, networkError, operation, forward, response}) => {
                var _a;
                if (graphQLErrors) {
                    for (const err of graphQLErrors) {
                        const oldHeaders = operation.getContext().headers;
                        const loggedIn = loggedInVar();
                        switch ((_a = err.extensions) === null || _a === void 0 ? void 0 : _a.code) {
                          case "UNAUTHENTICATED":
                            if (operation.operationName === "CurrentCustomer" && response) {
                                response.errors = undefined;
                                continue;
                            }
                            operation.setContext({
                                headers: Object.assign(Object.assign({}, oldHeaders), {
                                    forceRefresh: true
                                })
                            });
                            return forward(operation);

                          case "TOKEN_INVALID":
                            auth.logout();
                            if (!loggedIn) {
                                operation.setContext({
                                    headers: Object.assign(Object.assign({}, oldHeaders), {
                                        forceRefresh: true,
                                        includeAuthorization: false
                                    })
                                });
                                return forward(operation);
                            }
                            continue;

                          default:
                        }
                    }
                }
                if (networkError) {
                    console.log(`[Network error]: ${networkError}`);
                }
            });
            const tokenAwareHttpLink = errorHandlerLink.concat(httpLink);
            const cache = new client.InMemoryCache({
                possibleTypes,
                typePolicies: {
                    ItemId: {
                        keyFields: [ "id", "code" ]
                    },
                    Item: {
                        keyFields: [ "itemId", [ "id", "code" ] ]
                    },
                    ItemVariant: {
                        keyFields: [ "itemId", [ "id", "code" ] ]
                    },
                    Query: {
                        fields: {
                            findItemsByKeyword: {
                                keyArgs: this.keyArgsFunc,
                                merge: this.itemsMergeFunc
                            },
                            findItemsByCategory: {
                                keyArgs: this.keyArgsFunc,
                                merge: this.itemsMergeFunc
                            },
                            findItemsByWidget: {
                                keyArgs: this.keyArgsFunc,
                                merge: this.itemsMergeFunc
                            },
                            findOrders: {
                                keyArgs: this.keyArgsFunc,
                                merge: this.ordersMergeFunc
                            },
                            findWishlists: {
                                keyArgs: this.keyArgsFunc,
                                merge: this.wishlistsMergeFunc
                            }
                        }
                    }
                }
            });
            return new client.ApolloClient({
                cache,
                link: tokenAwareHttpLink,
                defaultOptions: {
                    query: {
                        errorPolicy: "all"
                    },
                    mutate: {
                        errorPolicy: "all"
                    },
                    watchQuery: {
                        errorPolicy: "all",
                        fetchPolicy: "cache-and-network",
                        nextFetchPolicy: "cache-first"
                    }
                }
            });
        }
        keyArgsFunc(args) {
            var _a;
            const keyArgs = Object.keys(args !== null && args !== void 0 ? args : {}).filter(key => ![ "offset", "queryHint" ].includes(key));
            const queryHintKeys = Object.keys((_a = args === null || args === void 0 ? void 0 : args.queryHint) !== null && _a !== void 0 ? _a : {}).filter(key => key !== "cursor");
            if (queryHintKeys.length) {
                keyArgs.push("queryHint", queryHintKeys);
            }
            return keyArgs;
        }
        itemsMergeFunc(existing, incoming, {args}) {
            var _a;
            const {offset = 0, queryHint} = args !== null && args !== void 0 ? args : {};
            if (!incoming) {
                return existing;
            }
            const merged = Object.assign({}, incoming);
            merged.items = [ ...(_a = existing === null || existing === void 0 ? void 0 : existing.items) !== null && _a !== void 0 ? _a : [] ];
            if (queryHint === null || queryHint === void 0 ? void 0 : queryHint.cursor) {
                merged.items.push(...incoming.items);
            } else {
                if (merged.items.length < offset) {
                    const oldLength = merged.items.length;
                    merged.items.length = offset;
                    merged.items.fill(null, oldLength);
                }
                incoming.items.forEach((item, i) => {
                    merged.items[offset + i] = item;
                });
            }
            return merged;
        }
        ordersMergeFunc(existing, incoming, {args}) {
            var _a;
            const {offset = 0, queryHint} = args !== null && args !== void 0 ? args : {};
            if (!incoming) {
                return existing;
            }
            const merged = Object.assign({}, incoming);
            merged.orders = [ ...(_a = existing === null || existing === void 0 ? void 0 : existing.orders) !== null && _a !== void 0 ? _a : [] ];
            if (queryHint === null || queryHint === void 0 ? void 0 : queryHint.cursor) {
                merged.orders.push(...incoming.orders);
            } else {
                incoming.orders.forEach((order, i) => {
                    merged.orders[offset + i] = order;
                });
            }
            return merged;
        }
        wishlistsMergeFunc(existing, incoming, {args}) {
            var _a;
            const {offset = 0, queryHint} = args !== null && args !== void 0 ? args : {};
            if (!incoming) {
                return existing;
            }
            const merged = Object.assign({}, incoming);
            merged.wishlists = [ ...(_a = existing === null || existing === void 0 ? void 0 : existing.wishlists) !== null && _a !== void 0 ? _a : [] ];
            if (queryHint === null || queryHint === void 0 ? void 0 : queryHint.cursor) {
                merged.wishlists.push(...incoming.wishlists);
            } else {
                incoming.wishlists.forEach((wishlist, i) => {
                    merged.wishlists[offset + i] = wishlist;
                });
            }
            return merged;
        }
    }
    function useQueryCustom(query, options, customQueryOptionsProcessor) {
        var _a, _b, _c;
        if (customQueryOptionsProcessor) {
            const processed = customQueryOptionsProcessor.process({
                query,
                options
            });
            if (processed) {
                query = (_a = processed.query) !== null && _a !== void 0 ? _a : query;
                options = (_b = processed.options) !== null && _b !== void 0 ? _b : options;
            }
        }
        const nextFetchPolicy = (_c = options === null || options === void 0 ? void 0 : options.nextFetchPolicy) !== null && _c !== void 0 ? _c : "cache-first";
        const nextFetchPolicyRef = React.useRef(nextFetchPolicy);
        const queryOptions = Object.assign({}, options !== null && options !== void 0 ? options : {});
        queryOptions.nextFetchPolicy = nextFetchPolicyRef.current;
        queryOptions.onError = error => {
            var _a;
            if (error.graphQLErrors) {
                nextFetchPolicyRef.current = "network-only";
            }
            (_a = options === null || options === void 0 ? void 0 : options.onError) === null || _a === void 0 ? void 0 : _a.call(options, error);
        };
        queryOptions.onCompleted = data => {
            var _a;
            nextFetchPolicyRef.current = nextFetchPolicy;
            (_a = options === null || options === void 0 ? void 0 : options.onCompleted) === null || _a === void 0 ? void 0 : _a.call(options, data);
        };
        return client.useQuery(query, queryOptions);
    }
    /**
   * A [React Context](https://reactjs.org/docs/context.html) object that provides access to configured
   * commerce properties defined in [[`CommerceConnectorContextProps`]] throughout a React component tree.
   *
   * Example:
   *
   * ~~~typescript
   * const { connector, graphqlServiceUrl, currentToken } = useContext(CommerceConnectorContext);
   * sessionStorage.setItem('token', currentToken); // store current token in session storage
   * ~~~
   *
   * @category CommerceConnectorContext
   */    const CommerceConnectorContext = React__default["default"].createContext({});
    /**
   * The `Consumer` component from the [React Context API](https://reactjs.org/docs/context.html) to access
   * the configured commerce properties [[`CommerceConnectorContextProps`]].
   *
   * Example:
   *
   * ~~~typescript
   * <CommerceConnectorConsumer>
   *   {{ connector, currentToken, graphqlServiceUrl } => (
   *     // do stuff here with the properties
   *   )}
   * </CommerceConnectorConsumer>
   * ~~~
   *
   * @category CommerceConnectorContext
   */    const CommerceConnectorConsumer = CommerceConnectorContext.Consumer;
    /**
   * The CommerceConnectorProvider component leverages [React's Context API](https://reactjs.org/docs/context.html)
   * to initialize the [Apollo client](https://www.apollographql.com/docs/react/) used for communicating with
   * the Commerce GraphQL Serivce. It also places configured commerce properties [[`CommerceConnectorContextProps`]]
   * on the context, which enables you to access it from anywhere in your component tree.
   * available throughout a React component tree.
   *
   * We suggest putting the CommerceConnectorProvider somewhere high in your app,
   * above any component that might need to access the Commerce GraphQL Serivce.
   * For example, it could be outside of your root route component if you're using React Router.
   *
   * Example:
   *
   * ~~~typescript
   * function App() {
   *   const connector = process.env.REACT_APP_DEFAULT_CONNECTOR;
   *   const graphqlServiceUrl = process.env.REACT_APP_DEFAULT_GRAPHQL_SERVICE_URL;
   *   const existingToken = sessionStorage.getItem('token'); // retrieve existing token from session storage
   *   return (
   *     <CommerceConnectorProvider
   *       connector={connector}
   *       graphqlServiceUrl={graphqlServiceUrl}
   *       existingToken={existingToken}
   *     >
   *       <div>
   *         <h2>My First Commerce App 🚀</h2>
   *       </div>
   *     </CommerceConnectorProvider>,
   *   );
   * }
   * ~~~
   *
   * @param props  A [[`CommerceConnectorContextInputProps`]] object
   * @category CommerceConnectorContext
   */    function CommerceConnectorProvider(props) {
        const {connector, existingToken, graphqlServiceUrl, defaultRequestHeaders, defaultAnonymousCredentials} = props;
        React.useState(() => {
            tokenVar(existingToken);
        });
        const currentToken = client.useReactiveVar(tokenVar);
        const commerceApiClient = React.useMemo(() => new CommerceApiClientFactory(graphqlServiceUrl, connector, defaultRequestHeaders, defaultAnonymousCredentials).createClient(), [ graphqlServiceUrl, connector, defaultRequestHeaders, defaultAnonymousCredentials ]);
        return React__default["default"].createElement(client.ApolloProvider, {
            client: commerceApiClient
        }, React__default["default"].createElement(CommerceConnectorContext.Provider, {
            value: {
                currentToken,
                connector,
                graphqlServiceUrl
            }
        }, props.children));
    }
    const MONEY_AMOUNT_FRAGMENT = client.gql`
  fragment MoneyAmountFragment on MoneyAmount {
    amount
    currency
    displayValue
    channelId
  }
`;
    const ITEM_LIKE_FRAGMENT = client.gql`
  fragment ItemLikeFragment on ItemLike {
    itemId {
      id
      code
    }
    displayName
    description
    imageSet {
      original {
        link {
          href
        }
      }
      thumbnail {
        link {
          href
        }
      }
      variants {
        name
        image {
          dimension {
            w
            h
          }
          link {
            href
          }
        }
      }
    }
    listPrice {
      moneyAmounts {
        ...MoneyAmountFragment
      }
    }
    purchasePrice {
      moneyAmounts {
        ...MoneyAmountFragment
      }
    }
  }

  ${MONEY_AMOUNT_FRAGMENT}
`;
    const ITEM_VARIANT_FRAGMENT = client.gql`
  fragment ItemVariantFragment on ItemVariant {
    ...ItemLikeFragment
    master
    varAttrs {
      name
      values
    }
    customAttrs {
      name
      values
    }
    mainItem {
      itemId {
        id
        code
      }
      displayName
      slug
    }
    availability {
      inStock
      availableQuantity
      restockableInDays
      channels {
        channelId
        inStock
        availableQuantity
        restockableInDays
      }
    }
  }

  ${ITEM_LIKE_FRAGMENT}
`;
    const ITEM_FRAGMENT = client.gql`
  fragment ItemFragment on Item {
    ...ItemLikeFragment
    varAttrTypes {
      name
    }
    salePriceRange
    priceRange
    customAttrs {
      name
      values
    }
    variants {
      ...ItemVariantFragment
    }
    slug
    categories {
      id
      displayName
      parentId
      path
      slug
    }
  }

  ${ITEM_LIKE_FRAGMENT}
  ${ITEM_VARIANT_FRAGMENT}
`;
    const FACET_RESULT_FRAGMENT = client.gql`
  fragment FacetResultFragment on FacetResult {
    fields {
      id
      name
      values {
        id
        parentId
        name
        count
      }
    }
    ranges {
      name
      id
      values {
        start
        end
        count
      }
    }
  }
`;
    const FIND_ITEMS_BY_KEYWORD = client.gql`
  query Items($query: String!, $offset: Int, $limit: Int, $queryHint: QueryHintInput, $sortFields: String) {
    findItemsByKeyword(text: $query, offset: $offset, limit: $limit, queryHint: $queryHint, sortFields: $sortFields) {
      offset
      limit
      count
      total
      items {
        ...ItemFragment
      }
      facetResult {
        ...FacetResultFragment
      }
      queryHint {
        cursor
        autoCorrectQuery
        autoCorrectQuerySet
        redirectHint {
          url
          query
          newQuery
        }
        statsFields {
          listPrice {
            max
            min
          }
          purchasePrice {
            max
            min
          }
        }
      }
    }
  }

  ${ITEM_FRAGMENT}
  ${FACET_RESULT_FRAGMENT}
`;
    const GET_ITEM_BY_ID = client.gql`
  query Item($id: String!, $queryHint: QueryHintInput) {
    findItemById(id: $id, queryHint: $queryHint) {
      ...ItemFragment
    }
  }

  ${ITEM_FRAGMENT}
`;
    const GET_ITEM_BY_SLUG = client.gql`
  query ItemBySlug($slug: String!, $queryHint: QueryHintInput) {
    findItemBySlug(slug: $slug, queryHint: $queryHint) {
      ...ItemFragment
    }
  }

  ${ITEM_FRAGMENT}
`;
    const FIND_ITEMS_BY_CATEGORY = client.gql`
  query ItemsByCategory(
    $categoryId: String!
    $offset: Int
    $limit: Int
    $queryHint: QueryHintInput
    $sortFields: String
  ) {
    findItemsByCategory(
      categoryId: $categoryId
      offset: $offset
      limit: $limit
      queryHint: $queryHint
      sortFields: $sortFields
    ) {
      offset
      limit
      count
      total
      items {
        ...ItemFragment
      }
      facetResult {
        ...FacetResultFragment
      }
      queryHint {
        cursor
        autoCorrectQuery
        autoCorrectQuerySet
        redirectHint {
          url
          query
          newQuery
        }
        statsFields {
          listPrice {
            max
            min
          }
          purchasePrice {
            max
            min
          }
        }
      }
    }
  }

  ${ITEM_FRAGMENT}
  ${FACET_RESULT_FRAGMENT}
`;
    const FIND_ITEMS_BY_WIDGET = client.gql`
  query ItemsByWidget(
    $query: String
    $pids: String
    $categoryId: String
    $offset: Int
    $limit: Int
    $queryHint: QueryHintInput
    $sortFields: String
  ) {
    findItemsByWidget(
      text: $query
      pids: $pids
      categoryId: $categoryId
      offset: $offset
      limit: $limit
      queryHint: $queryHint
      sortFields: $sortFields
    ) {
      offset
      limit
      count
      total
      items {
        ...ItemFragment
      }
      facetResult {
        ...FacetResultFragment
      }
      queryHint {
        cursor
        autoCorrectQuery
        autoCorrectQuerySet
        redirectHint {
          url
          query
          newQuery
        }
        statsFields {
          listPrice {
            max
            min
          }
          purchasePrice {
            max
            min
          }
        }
      }
    }
  }

  ${ITEM_FRAGMENT}
  ${FACET_RESULT_FRAGMENT}
`;
    const DISCOUNT_FRAGMENT = client.gql`
  fragment DiscountFragment on Discount {
    id
    code
    description
    name
    targetIds
    type
    value {
      moneyAmounts {
        amount
        currency
        displayValue
      }
      numericalAmount
      type
    }
  }
`;
    const DISCOUNT_CODE_FRAGMENT = client.gql`
  fragment DiscountCodeFragment on DiscountCode {
    id
    code
    name
    refs
  }
`;
    const CART_FRAGMENT = client.gql`
  fragment CartFragment on Cart {
    id
    totalQuantity
    revision
    totalListPrice {
      moneyAmounts {
        ...MoneyAmountFragment
      }
    }
    totalPurchasePrice {
      moneyAmounts {
        ...MoneyAmountFragment
      }
    }
    active
    state
    entries {
      id
      quantity
      listPrice {
        moneyAmounts {
          ...MoneyAmountFragment
        }
      }
      purchasePrice {
        moneyAmounts {
          ...MoneyAmountFragment
        }
      }
      customAttrs {
        name
        values
      }
      items {
        ... on Item {
          ...ItemFragment
        }
        ... on ItemVariant {
          ...ItemVariantFragment
        }
      }
    }
    discounts {
      ...DiscountFragment
    }
    discountCodes {
      ...DiscountCodeFragment
    }
  }

  ${ITEM_FRAGMENT}
  ${ITEM_VARIANT_FRAGMENT}
  ${MONEY_AMOUNT_FRAGMENT}
  ${DISCOUNT_FRAGMENT}
  ${DISCOUNT_CODE_FRAGMENT}
`;
    const ADD_TO_CART = client.gql`
  mutation AddToCart($input: AddToCartInput!, $cartHint: CartHintInput) {
    addToCart(addToCartInput: $input, cartHint: $cartHint) {
      code
      success
      message
      cart {
        ...CartFragment
      }
    }
  }

  ${CART_FRAGMENT}
`;
    const UPDATE_CART = client.gql`
  mutation UpdateCart($input: UpdateCartInput!, $cartHint: CartHintInput) {
    updateCart(updateCartInput: $input, cartHint: $cartHint) {
      code
      success
      message
      cart {
        ...CartFragment
      }
    }
  }

  ${CART_FRAGMENT}
`;
    const REMOVE_FROM_CART = client.gql`
  mutation RemoveFromCart($input: RemoveFromCartInput!, $cartHint: CartHintInput) {
    removeFromCart(removeFromCartInput: $input, cartHint: $cartHint) {
      code
      success
      message
      cart {
        ...CartFragment
      }
    }
  }

  ${CART_FRAGMENT}
`;
    const UPDATE_CART_BY_ORDER = client.gql`
  mutation UpdateCartByOrder($orderId: String!, $cartHint: CartHintInput) {
    updateCartByOrder(orderId: $orderId, cartHint: $cartHint) {
      code
      success
      message
      cart {
        ...CartFragment
      }
    }
  }

  ${CART_FRAGMENT}
`;
    const REMOVE_CART = client.gql`
  mutation RemoveCart($cartId: String, $cartHint: CartHintInput) {
    removeCart(cartId: $cartId, cartHint: $cartHint) {
      code
      success
      message
      cart {
        ...CartFragment
      }
    }
  }

  ${CART_FRAGMENT}
`;
    const CREATE_CART = client.gql`
  mutation CreateCart($createCartInput: CreateCartInput!, $cartHint: CartHintInput) {
    createCart(createCartInput: $createCartInput, cartHint: $cartHint) {
      code
      success
      message
      cart {
        ...CartFragment
      }
    }
  }

  ${CART_FRAGMENT}
`;
    const GET_CART = client.gql`
  query Cart($id: String, $cartHint: CartHintInput) {
    getCart(id: $id, cartHint: $cartHint) {
      ...CartFragment
    }
  }

  ${CART_FRAGMENT}
`;
    const CUSTOMER_FRAGMENT = client.gql`
  fragment CustomerFragment on Customer {
    id
    email
    firstName
    middleName
    lastName
    title
    salutation
    companyName
    dateOfBirth
    customAttrs {
      name
      values
    }
  }
`;
    const GET_CURRENT_CUSTOMER = client.gql`
  query CurrentCustomer {
    getCurrentCustomer {
      ...CustomerFragment
    }
  }

  ${CUSTOMER_FRAGMENT}
`;
    function refreshCustomer(client) {
        return __awaiter(this, void 0, void 0, (function*() {
            const result = yield client.query({
                query: GET_CURRENT_CUSTOMER,
                fetchPolicy: "network-only",
                errorPolicy: "all"
            });
            const currentCustomer = result.data.getCurrentCustomer;
            if (currentCustomer) {
                loggedInVar(true);
            }
            return currentCustomer;
        }));
    }
    function refreshCart(client) {
        var _a;
        return __awaiter(this, void 0, void 0, (function*() {
            const result = yield client.query({
                query: GET_CART,
                fetchPolicy: "network-only",
                errorPolicy: "all"
            });
            if ((_a = result.data.getCart) === null || _a === void 0 ? void 0 : _a.id) {
                client.writeQuery({
                    query: GET_CART,
                    variables: {
                        id: result.data.getCart.id
                    },
                    data: result.data
                });
            }
            return result.data.getCart;
        }));
    }
    function getPaginatedItems(existing) {
        const {offset, count} = existing;
        const result = Object.assign({}, existing);
        result.items = existing.items.slice(offset, offset + count);
        return result;
    }
    function getPaginatedWishlists(existing) {
        const {offset, count} = existing;
        const result = Object.assign({}, existing);
        result.wishlists = existing.wishlists.slice(offset, offset + count);
        return result;
    }
    /**
   * Custom Hook for product search grids.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [onLoadMore, itemsPageResult, loading, error] = useProductGridSearch({
   *   connector,
   *   customAttrFields,
   *   customVariantAttrFields,
   *   facetFieldFilters,
   *   pageSize,
   *   offset,
   *   sortFields,
   *   smViewId,
   *   searchText: query,
   *   brUid2: cookies._br_uid_2,
   * });
   *
   * // To fetch the next page
   * const handleLoadMore = () => {
   *   onLoadMore();
   * }
   * ~~~
   *
   * @param {@linkcode ProductGridSearchInputProps}
   * @returns An array constitutes of the following:
   * - `onLoadMore`: A function that enables pagination for your query.
   *   You can pass in an `offset` for the starting point of a page,
   *   or leave it undefined for an infinite-scroll style pagination.
   * - `itemsPageResult`: An object containing the search result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Product
   */    function useProductGridSearch({searchText, facetFieldFilters, pageSize, offset: start, sortFields, customAttrFields, customVariantAttrFields, smViewId, connector, brUid2, customVariantListPriceField, customVariantPurchasePriceField, params, smAccountId, smAuthKey, smDomainKey, storeKey, customQueryOptionsProcessor, brEnvType}) {
        const continuousLoadRef = React.useRef(false);
        const queryOptions = {
            variables: {
                query: searchText !== null && searchText !== void 0 ? searchText : "",
                offset: start !== null && start !== void 0 ? start : 0,
                limit: pageSize,
                queryHint: {
                    facetFieldFilters,
                    brUid2,
                    customAttrFields,
                    customVariantAttrFields,
                    customVariantListPriceField,
                    customVariantPurchasePriceField,
                    params,
                    viewId: smViewId,
                    accountId: smAccountId,
                    authKey: smAuthKey,
                    domainKey: smDomainKey,
                    storeKey,
                    brEnvType
                },
                sortFields
            }
        };
        if (connector) {
            queryOptions.context = {
                headers: {
                    connector
                }
            };
        }
        const {loading, data, fetchMore, error} = useQueryCustom(FIND_ITEMS_BY_KEYWORD, queryOptions, customQueryOptionsProcessor);
        if (!(data === null || data === void 0 ? void 0 : data.findItemsByKeyword)) {
            return [ () => Promise.resolve(), undefined, loading, error ];
        }
        const {findItemsByKeyword} = data;
        const {offset, count, queryHint} = findItemsByKeyword;
        const onLoadMore = offsetParam => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const variables = (queryHint === null || queryHint === void 0 ? void 0 : queryHint.cursor) ? {
                queryHint: Object.assign(Object.assign({}, (_a = queryOptions.variables) === null || _a === void 0 ? void 0 : _a.queryHint), {
                    cursor: queryHint.cursor
                })
            } : {
                offset: offsetParam !== null && offsetParam !== void 0 ? offsetParam : offset + count
            };
            continuousLoadRef.current = offsetParam == null;
            yield fetchMore({
                variables
            });
        }));
        let result = findItemsByKeyword;
        if (!continuousLoadRef.current && !(queryHint === null || queryHint === void 0 ? void 0 : queryHint.cursor)) {
            result = getPaginatedItems(findItemsByKeyword);
        }
        return [ onLoadMore, result, loading, error ];
    }
    /**
   * React HOC for product search grids.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a product grid.
   * function ProductGridSearch({ itemsPageResult, loading, onLoadMore, error }: ProductGridSearchProps) {
   *   // To fetch the next page
   *   const handleLoadMore = () => {
   *     onLoadMore();
   *   }
   *
   *   return (
   *     // renders a product grid
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedProductGridSearch = withProductGridSearch(ProductGridSearch);
   *
   * // Use the enhanced component.
   * <EnhancedProductGridSearch
   *   connector={connector}
   *   customAttrFields={customAttrFields}
   *   customVariantAttrFields={customVariantAttrFields}
   *   facetFieldFilters={facetFieldFilters}
   *   pageSize={pageSize}
   *   offset={offset}
   *   sortFields={sortFields}
   *   smViewId={smViewId}
   *   searchText={query}
   *   brUid2={cookies._br_uid_2}
   * />
   * ~~~
   *
   * @category Product
   */    function withProductGridSearch(Component) {
        return _a => {
            var {searchText, facetFieldFilters, pageSize, offset, sortFields, customAttrFields, customVariantAttrFields, smViewId, connector, brUid2, customVariantListPriceField, customVariantPurchasePriceField, params, smAccountId, smAuthKey, smDomainKey, storeKey, brEnvType} = _a, props = __rest(_a, [ "searchText", "facetFieldFilters", "pageSize", "offset", "sortFields", "customAttrFields", "customVariantAttrFields", "smViewId", "connector", "brUid2", "customVariantListPriceField", "customVariantPurchasePriceField", "params", "smAccountId", "smAuthKey", "smDomainKey", "storeKey", "brEnvType" ]);
            const [onLoadMore, result, loading, error] = useProductGridSearch({
                searchText,
                facetFieldFilters,
                pageSize,
                offset,
                sortFields,
                customAttrFields,
                customVariantAttrFields,
                smViewId,
                connector,
                brUid2,
                customVariantListPriceField,
                customVariantPurchasePriceField,
                params,
                smAccountId,
                smAuthKey,
                smDomainKey,
                storeKey,
                brEnvType
            });
            return React__default["default"].createElement(Component, Object.assign({
                itemsPageResult: result,
                loading,
                onLoadMore,
                error
            }, props));
        };
    }
    /**
   * Custom Hook for product search grids, using the Pathways and Recommendations API v2.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [onLoadMore, itemsPageResult, loading, error] = useProductGridWidget({
   *   widgetType,
   *   widgetId,
   *   productIds,
   *   categoryId,
   *   customAttrFields,
   *   customVariantAttrFields,
   *   facetFieldFilters,
   *   pageSize,
   *   offset,
   *   sortFields,
   *   smViewId,
   *   searchText: query,
   *   brUid2: cookies._br_uid_2,
   * });
   *
   * // To fetch the next page
   * const handleLoadMore = () => {
   *   onLoadMore();
   * }
   * ~~~
   *
   * @param {@linkcode ProductGridWidgetInputProps}
   * @returns An array constitutes of the following:
   * - `onLoadMore`: A function that enables pagination for your query.
   *   You can pass in an `offset` for the starting point of a page,
   *   or leave it undefined for an infinite-scroll style pagination.
   * - `itemsPageResult`: An object containing the search result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Product
   */    function useProductGridWidget({widgetType, widgetId, searchText, productIds, categoryId, facetFieldFilters, pageSize, offset: start, sortFields, customAttrFields, customVariantAttrFields, smViewId, brUid2, customVariantListPriceField, customVariantPurchasePriceField, params, smAccountId, smAuthKey, smDomainKey, smCatalogViews, storeKey, customQueryOptionsProcessor, brEnvType}) {
        const continuousLoadRef = React.useRef(false);
        const queryOptions = {
            variables: {
                query: searchText !== null && searchText !== void 0 ? searchText : "",
                pids: (productIds !== null && productIds !== void 0 ? productIds : []).join(","),
                categoryId,
                offset: start !== null && start !== void 0 ? start : 0,
                limit: pageSize,
                queryHint: {
                    widgetType,
                    widgetId,
                    facetFieldFilters,
                    brUid2,
                    customAttrFields,
                    customVariantAttrFields,
                    customVariantListPriceField,
                    customVariantPurchasePriceField,
                    params,
                    viewId: smViewId,
                    accountId: smAccountId,
                    authKey: smAuthKey,
                    domainKey: smDomainKey,
                    catalogViews: smCatalogViews,
                    storeKey,
                    brEnvType
                },
                sortFields
            }
        };
        let paramsError;
        if (!widgetType || !widgetId) {
            paramsError = new Error("Invalid widget configuration");
            queryOptions.skip = true;
        }
        queryOptions.context = {
            headers: {
                connector: "brsm"
            }
        };
        const {loading, data, fetchMore, error} = useQueryCustom(FIND_ITEMS_BY_WIDGET, queryOptions, customQueryOptionsProcessor);
        if (!(data === null || data === void 0 ? void 0 : data.findItemsByWidget)) {
            return [ () => Promise.resolve(), undefined, loading, paramsError !== null && paramsError !== void 0 ? paramsError : error ];
        }
        const {findItemsByWidget} = data;
        const {offset, count, queryHint} = findItemsByWidget;
        const onLoadMore = offsetParam => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const variables = (queryHint === null || queryHint === void 0 ? void 0 : queryHint.cursor) ? {
                queryHint: Object.assign(Object.assign({}, (_a = queryOptions.variables) === null || _a === void 0 ? void 0 : _a.queryHint), {
                    cursor: queryHint.cursor
                })
            } : {
                offset: offsetParam !== null && offsetParam !== void 0 ? offsetParam : offset + count
            };
            continuousLoadRef.current = offsetParam == null;
            yield fetchMore({
                variables
            });
        }));
        let result = findItemsByWidget;
        if (!continuousLoadRef.current) {
            result = getPaginatedItems(findItemsByWidget);
        }
        return [ onLoadMore, result, loading, error ];
    }
    /**
   * React HOC for product search grids, using the Pathways and Recommendations API v2.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a product grid, using the Pathways and Recommendations API v2.
   * function ProductGridWidget({ itemsPageResult, loading, onLoadMore, error }: ProductGridWidgetProps) {
   *   // To fetch the next page
   *   const handleLoadMore = () => {
   *     onLoadMore();
   *   }
   *
   *   return (
   *     // renders a product grid
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedProductGridWidget = withProductGridWidget(ProductGridWidget);
   *
   * // Use the enhanced component.
   * <EnhancedProductGridWidget
   *   widgetType={widgetType}
   *   widgetId={widgetId}
   *   customAttrFields={customAttrFields}
   *   customVariantAttrFields={customVariantAttrFields}
   *   facetFieldFilters={facetFieldFilters}
   *   pageSize={pageSize}
   *   sortFields={sortFields}
   *   smViewId={smViewId}
   *   searchText={query}
   *   productIds={productIds}
   *   categoryId={categoryId}
   *   brUid2={cookies._br_uid_2}
   * />
   * ~~~
   *
   * @category Product
   */    function withProductGridWidget(Component) {
        return _a => {
            var {widgetType, widgetId, searchText, productIds, categoryId, facetFieldFilters, pageSize, sortFields, customAttrFields, customVariantAttrFields, smViewId, brUid2, customVariantListPriceField, customVariantPurchasePriceField, params, smAccountId, smAuthKey, smDomainKey, smCatalogViews, storeKey, brEnvType} = _a, props = __rest(_a, [ "widgetType", "widgetId", "searchText", "productIds", "categoryId", "facetFieldFilters", "pageSize", "sortFields", "customAttrFields", "customVariantAttrFields", "smViewId", "brUid2", "customVariantListPriceField", "customVariantPurchasePriceField", "params", "smAccountId", "smAuthKey", "smDomainKey", "smCatalogViews", "storeKey", "brEnvType" ]);
            const [onLoadMore, result, loading, error] = useProductGridWidget({
                widgetType,
                widgetId,
                searchText,
                productIds,
                categoryId,
                facetFieldFilters,
                pageSize,
                sortFields,
                customAttrFields,
                customVariantAttrFields,
                smViewId,
                brUid2,
                customVariantListPriceField,
                customVariantPurchasePriceField,
                params,
                smAccountId,
                smAuthKey,
                smDomainKey,
                smCatalogViews,
                storeKey,
                brEnvType
            });
            return React__default["default"].createElement(Component, Object.assign({
                itemsPageResult: result,
                loading,
                onLoadMore,
                error
            }, props));
        };
    }
    /**
   * Custom Hook for product detail.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [item, loading, error] = useProductDetail({
   *   itemId,
   *   smViewId,
   *   brUid2,
   *   connector,
   *   customAttrFields,
   *   customVariantAttrFields,
   * });
   * ~~~
   *
   * @param [[`ProductDetailInputProps`]]
   * @returns An array constitutes of the following:
   * - `item`: An object containing the [[`ItemFragment`]] result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Product
   */    function useProductDetail({itemId, slug, smViewId, brUid2, connector, customAttrFields, customVariantAttrFields, customVariantListPriceField, customVariantPurchasePriceField, params, smAccountId, smAuthKey, smDomainKey, storeKey, customQueryOptionsProcessor, brEnvType}) {
        const queryHint = {
            customAttrFields,
            customVariantAttrFields,
            brUid2,
            customVariantListPriceField,
            customVariantPurchasePriceField,
            params,
            viewId: smViewId,
            accountId: smAccountId,
            authKey: smAuthKey,
            domainKey: smDomainKey,
            storeKey,
            brEnvType
        };
        let queryOptions = {};
        if (connector) {
            queryOptions.context = {
                headers: {
                    connector
                }
            };
        }
        if (slug) {
            queryOptions = Object.assign(Object.assign({}, queryOptions), {
                variables: {
                    slug,
                    queryHint
                }
            });
        } else {
            queryOptions = Object.assign(Object.assign({}, queryOptions), {
                variables: {
                    id: typeof itemId === "string" ? itemId : `${itemId.id}___${itemId.code}`,
                    queryHint
                }
            });
        }
        const {loading, data, error} = useQueryCustom(slug ? GET_ITEM_BY_SLUG : GET_ITEM_BY_ID, queryOptions, customQueryOptionsProcessor);
        const resultData = data !== null && data !== void 0 ? data : {};
        const item = "findItemBySlug" in resultData ? resultData.findItemBySlug : resultData.findItemById;
        return [ item !== null && item !== void 0 ? item : undefined, loading, error ];
    }
    /**
   * React HOC for product detail.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a product detail.
   * function ProductDetail({ loading, item, error }: ProductDetailProps) {
   *   return (
   *     // renders the product detail
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedProductDetail = withProductDetail(ProductDetail);
   *
   * // Use the enhanced component.
   * <EnhancedProductDetail
   *   itemId={itemId}
   *   smViewId={smViewId}
   *   brUid2={cookies._br_uid_2}
   *   connector={connector}
   *   customAttrFields={customAttrFields}
   *   customVariantAttrFields={customVariantAttrFields}
   * />
   * ~~~
   *
   * @category Product
   */    function withProductDetail(Component) {
        return _a => {
            var {itemId, customAttrFields, customVariantAttrFields, connector, smViewId, brUid2, customVariantListPriceField, customVariantPurchasePriceField, params, smAccountId, smAuthKey, smDomainKey, storeKey, brEnvType} = _a, props = __rest(_a, [ "itemId", "customAttrFields", "customVariantAttrFields", "connector", "smViewId", "brUid2", "customVariantListPriceField", "customVariantPurchasePriceField", "params", "smAccountId", "smAuthKey", "smDomainKey", "storeKey", "brEnvType" ]);
            const [result, loading, error] = useProductDetail({
                itemId,
                customAttrFields,
                customVariantAttrFields,
                connector,
                smViewId,
                brUid2,
                customVariantListPriceField,
                customVariantPurchasePriceField,
                params,
                smAccountId,
                smAuthKey,
                smDomainKey,
                storeKey,
                brEnvType
            });
            return React__default["default"].createElement(Component, Object.assign({
                item: result,
                loading,
                error
            }, props));
        };
    }
    /**
   * Custom Hook for product category grids.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [onLoadMore, itemsPageResult, loading, error] = useProductGridCategory({
   *   categoryId,
   *   facetFieldFilters,
   *   pageSize,
   *   offset,
   *   sortFields,
   *   customAttrFields,
   *   customVariantAttrFields,
   *   smViewId,
   *   connector,
   *   brUid2: cookies._br_uid_2,
   * });
   *
   * // To fetch the next page
   * const handleLoadMore = () => {
   *   onLoadMore();
   * }
   * ~~~
   *
   * @param [[`ProductGridCategoryInputProps`]]
   * @returns An array constitutes of the following:
   * - `onLoadMore`: A function that enables pagination for your query.
   *   You can pass in an `offset` for the starting point of a page,
   *   or leave it undefined for an infinite-scroll style pagination.
   * - `itemsPageResult`: An object containing the search result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Product
   */    function useProductGridCategory({categoryId, facetFieldFilters, pageSize, offset: start, sortFields, customAttrFields, customVariantAttrFields, smViewId, connector, brUid2, customVariantListPriceField, customVariantPurchasePriceField, params, smAccountId, smAuthKey, smDomainKey, storeKey, customQueryOptionsProcessor, brEnvType}) {
        const continuousLoadRef = React.useRef(false);
        const queryOptions = {
            variables: {
                categoryId,
                offset: start !== null && start !== void 0 ? start : 0,
                limit: pageSize,
                queryHint: {
                    facetFieldFilters,
                    brUid2,
                    customAttrFields,
                    customVariantAttrFields,
                    customVariantListPriceField,
                    customVariantPurchasePriceField,
                    params,
                    viewId: smViewId,
                    accountId: smAccountId,
                    authKey: smAuthKey,
                    domainKey: smDomainKey,
                    storeKey,
                    brEnvType
                },
                sortFields
            }
        };
        if (connector) {
            queryOptions.context = {
                headers: {
                    connector
                }
            };
        }
        const {loading, data, fetchMore, error} = useQueryCustom(FIND_ITEMS_BY_CATEGORY, queryOptions, customQueryOptionsProcessor);
        if (!(data === null || data === void 0 ? void 0 : data.findItemsByCategory)) {
            return [ () => Promise.resolve(), undefined, loading, error ];
        }
        const {findItemsByCategory} = data;
        const {offset, count, queryHint} = findItemsByCategory;
        const onLoadMore = offsetParam => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const variables = (queryHint === null || queryHint === void 0 ? void 0 : queryHint.cursor) ? {
                queryHint: Object.assign(Object.assign({}, (_a = queryOptions.variables) === null || _a === void 0 ? void 0 : _a.queryHint), {
                    cursor: queryHint.cursor
                })
            } : {
                offset: offsetParam !== null && offsetParam !== void 0 ? offsetParam : offset + count
            };
            continuousLoadRef.current = offsetParam == null;
            yield fetchMore({
                variables
            });
        }));
        let result = findItemsByCategory;
        if (!continuousLoadRef.current) {
            result = getPaginatedItems(findItemsByCategory);
        }
        return [ onLoadMore, result, loading, error ];
    }
    /**
   * React HOC for product category grids.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a product grid.
   * function ProductGridCategory({ itemsPageResult, loading, onLoadMore, error }: ProductGridCategoryProps) {
   *   // To fetch the next page
   *   const handleLoadMore = () => {
   *     onLoadMore();
   *   }
   *
   *   return (
   *     // renders a product grid
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedProductGridCategory = withProductGridCategory(ProductGridCategory);
   *
   * // Use the enhanced component.
   * <EnhancedProductGridCategory
   *   categoryId={categoryId}
   *   connector={connector}
   *   facetFieldFilters={facetFieldFilters}
   *   pageSize={pageSize}
   *   offset={offset}
   *   sortFields={sortFields}
   *   customAttrFields={customAttrFields}
   *   customVariantAttrFields={customVariantAttrFields}
   *   smViewId={smViewId}
   *   searchText={query}
   *   brUid2={cookies._br_uid_2}
   * />
   * ~~~
   *
   * @category Product
   */    function withProductGridCategory(Component) {
        return _a => {
            var {categoryId, facetFieldFilters, pageSize, offset, sortFields, customAttrFields, customVariantAttrFields, smViewId, connector, brUid2, customVariantListPriceField, customVariantPurchasePriceField, params, smAccountId, smAuthKey, smDomainKey, storeKey, brEnvType} = _a, props = __rest(_a, [ "categoryId", "facetFieldFilters", "pageSize", "offset", "sortFields", "customAttrFields", "customVariantAttrFields", "smViewId", "connector", "brUid2", "customVariantListPriceField", "customVariantPurchasePriceField", "params", "smAccountId", "smAuthKey", "smDomainKey", "storeKey", "brEnvType" ]);
            const [onLoadMore, result, loading, error] = useProductGridCategory({
                categoryId,
                facetFieldFilters,
                pageSize,
                offset,
                sortFields,
                customAttrFields,
                customVariantAttrFields,
                smViewId,
                connector,
                brUid2,
                customVariantListPriceField,
                customVariantPurchasePriceField,
                params,
                smAccountId,
                smAuthKey,
                smDomainKey,
                storeKey,
                brEnvType
            });
            return React__default["default"].createElement(Component, Object.assign({
                itemsPageResult: result,
                loading,
                onLoadMore,
                error
            }, props));
        };
    }
    const FIND_SUGGESTIONS = client.gql`
  query Suggestions($text: String!, $queryHint: QueryHintInput) {
    findSuggestions(text: $text, queryHint: $queryHint) {
      terms
      items {
        itemId {
          id
          code
        }
        displayName
        description
        imageSet {
          thumbnail {
            link {
              href
            }
          }
        }
        listPrice {
          moneyAmounts {
            ...MoneyAmountFragment
          }
        }
        purchasePrice {
          moneyAmounts {
            ...MoneyAmountFragment
          }
        }
      }
    }
  }
  ${MONEY_AMOUNT_FRAGMENT}
`
    /**
   * Custom Hook for product suggestion search.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [result, loading, error] = useProductSearchSuggestion({
   *   text,
   *   connector,
   * });
   * ~~~
   *
   * @param [[`ProductSearchSuggestionInputProps`]]
   * @returns An array constitutes of the following:
   * - `result`: An object containing the search result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Product
   */;
    function useProductSearchSuggestion({text, connector, smViewId, brUid2, params, smAccountId, smAuthKey, smDomainKey, smCatalogViews, storeKey, brEnvType}) {
        var _a;
        const queryOptions = {
            variables: {
                text,
                queryHint: {
                    brUid2,
                    params,
                    accountId: smAccountId,
                    authKey: smAuthKey,
                    domainKey: smDomainKey,
                    viewId: smViewId,
                    catalogViews: smCatalogViews,
                    storeKey,
                    brEnvType
                }
            },
            context: {
                headers: {
                    connector: connector !== null && connector !== void 0 ? connector : "brsm"
                }
            },
            fetchPolicy: "no-cache",
            nextFetchPolicy: "no-cache"
        };
        const {loading, data, error} = client.useQuery(FIND_SUGGESTIONS, queryOptions);
        return [ (_a = data === null || data === void 0 ? void 0 : data.findSuggestions) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for product suggestion search.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders the product suggestion result.
   * function ProductSearchSuggestion({ result, loading, error }: ProductSearchSuggestionProps) {
   *   return (
   *     // renders the product suggestion result
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedProductSearchSuggestion = withProductSearchSuggestion(ProductSearchSuggestion);
   *
   * // Use the enhanced component.
   * <EnhancedProductSearchSuggestion
   *   text={text}
   *   connector={connector}
   * />
   * ~~~
   *
   * @category Product
   */    function withProductSearchSuggestion(Component) {
        return _a => {
            var {text, connector, smViewId, brUid2, params, smAccountId, smAuthKey, smDomainKey, storeKey, brEnvType} = _a, props = __rest(_a, [ "text", "connector", "smViewId", "brUid2", "params", "smAccountId", "smAuthKey", "smDomainKey", "storeKey", "brEnvType" ]);
            const [result, loading, error] = useProductSearchSuggestion({
                text,
                connector,
                smViewId,
                brUid2,
                params,
                smAccountId,
                smAuthKey,
                smDomainKey,
                storeKey,
                brEnvType
            });
            return React__default["default"].createElement(Component, Object.assign({
                result,
                loading,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to add an item to the cart.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [addToCart, result, loading, error] = useAddToCart({ cartId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle "Add To Cart" button click
   * const handleButtonClick = () => {
   *   addToCart({
   *     itemId,
   *     quantity,
   *     customAttrs,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `addToCart`: A function to trigger the `addToCart` mutation from your UI.
   *   You can pass [[`AddToCartParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`AddToCart_addToCart | AddToCartResult`]].
   * - `result`: The [[`AddToCart_addToCart | AddToCartResult`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */    function useAddToCart({cartId, storeKey, distributionChannel}) {
        const [mutate, {data, loading, error}] = client.useMutation(ADD_TO_CART);
        const addToCart = params => __awaiter(this, void 0, void 0, (function*() {
            var _a, _b, _c;
            const {quantity, itemId, customAttrs} = params;
            const result = yield mutate({
                variables: {
                    input: {
                        cartId,
                        quantity,
                        customAttrs,
                        itemId: `${(_a = itemId.id) !== null && _a !== void 0 ? _a : ""}___${(_b = itemId.code) !== null && _b !== void 0 ? _b : ""}`
                    },
                    cartHint: {
                        storeKey,
                        distributionChannel
                    }
                }
            });
            return (_c = result.data) === null || _c === void 0 ? void 0 : _c.addToCart;
        }));
        return [ addToCart, data === null || data === void 0 ? void 0 : data.addToCart, loading, error ];
    }
    /**
   * React HOC for adding an item to cart.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Add To Cart" button.
   * function AddToCartButton({ addToCart, loading, result, error }: AddToCartProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     addToCart({
   *       itemId,
   *       quantity,
   *       customAttrs,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Add To Cart" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedAddToCartButton = withAddToCart(AddToCartButton);
   *
   * // Use the enhanced component.
   * <EnhancedAddToCartButton cartId={cartId} />
   * ~~~
   *
   * @category Cart
   */    function withAddToCart(Component) {
        return _a => {
            var {cartId, storeKey, distributionChannel} = _a, props = __rest(_a, [ "cartId", "storeKey", "distributionChannel" ]);
            const [addToCart, result, loading, error] = useAddToCart({
                cartId,
                storeKey,
                distributionChannel
            });
            return React__default["default"].createElement(Component, Object.assign({
                addToCart,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook for fetching a cart.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [cart, loading, error] = useCart({ cartId });
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `cart`: An object containing the [[`CartFragment`]] result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   * - `refetch `: A function that enables to refresh query results in response to a particular user action
   *
   * @category Cart
   */    function useCart({cartId, storeKey, customQueryOptionsProcessor}) {
        var _a;
        const queryOptions = {
            variables: {
                id: cartId,
                cartHint: {
                    storeKey
                }
            }
        };
        if (!cartId) {
            queryOptions.fetchPolicy = "network-only";
            queryOptions.nextFetchPolicy = "network-only";
        }
        const {loading, data, error, refetch} = useQueryCustom(GET_CART, queryOptions, customQueryOptionsProcessor);
        return [ (_a = data === null || data === void 0 ? void 0 : data.getCart) !== null && _a !== void 0 ? _a : undefined, loading, error, refetch ];
    }
    /**
   * React HOC for fetching a cart.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a cart.
   * function Cart({ loading, cart, error, refetch }: CartProps) {
   *   return (
   *     // renders a cart
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedCart = withCart(Cart);
   *
   * // Use the enhanced component.
   * <EnhancedCart cartId={cartId} />
   * ~~~
   *
   * @category Cart
   */    function withCart(Component) {
        return _a => {
            var {cartId, storeKey} = _a, props = __rest(_a, [ "cartId", "storeKey" ]);
            const [result, loading, error, refetch] = useCart({
                cartId,
                storeKey
            });
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                cart: result,
                error,
                refetch
            }, props));
        };
    }
    /**
   * Custom Hook to remove an entry from cart.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [removeFromCart, result, loading, error] = useRemoveFromCart({ cartId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle "Remove From Cart" button click
   * const handleButtonClick = () => {
   *   removeFromCart({ entryId });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `removeFromCart`: A function to trigger the `removeFromCart` mutation from your UI.
   *   You can pass [[`RemoveFromCartParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`RemoveFromCart_removeFromCart | RemoveFromCartResponse`]].
   * - `result`: The [[`RemoveFromCart_removeFromCart | RemoveFromCartResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */    function useRemoveFromCart({cartId, storeKey, distributionChannel}) {
        const [mutate, {data, loading, error}] = client.useMutation(REMOVE_FROM_CART);
        const removeFromCart = ({entryId}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    input: {
                        cartId,
                        entryId
                    },
                    cartHint: {
                        storeKey,
                        distributionChannel
                    }
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.removeFromCart;
        }));
        return [ removeFromCart, data === null || data === void 0 ? void 0 : data.removeFromCart, loading, error ];
    }
    /**
   * React HOC for removing an entry from cart.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Remove From Cart" button.
   * function RemoveFromCartButton({ removeFromCart, loading, result, error }: RemoveFromCartProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     removeFromCart({ entryId });
   *   }
   *
   *   return (
   *     // renders the "Remove From Cart" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedRemoveFromCartButton = withRemoveFromCart(RemoveFromCartButton);
   *
   * // Use the enhanced component.
   * <EnhancedRemoveFromCartButton cartId={cartId} />
   * ~~~
   *
   * @category Cart
   */    function withRemoveFromCart(Component) {
        return _a => {
            var {cartId, storeKey, distributionChannel} = _a, props = __rest(_a, [ "cartId", "storeKey", "distributionChannel" ]);
            const [removeFromCart, result, loading, error] = useRemoveFromCart({
                cartId,
                storeKey,
                distributionChannel
            });
            return React__default["default"].createElement(Component, Object.assign({
                removeFromCart,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to update a cart entry.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [updateCart, result, loading, error] = useUpdateCartItem({ cartId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   updateCart({
   *     entryId,
   *     quantity,
   *     customAttrs,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `updateCart`: A function to trigger the `updateCart` mutation from your UI.
   *   You can pass [[`UpdateCartItemParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`UpdateCart_updateCart | UpdateCartResponse`]].
   * - `result`: The [[`UpdateCart_updateCart | UpdateCartResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */    function useUpdateCartItem({cartId, storeKey, distributionChannel}) {
        const [error, setError] = React.useState();
        const [mutate, {data, loading}] = client.useMutation(UPDATE_CART);
        const updateCart = ({entryId, quantity, customAttrs}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            if (!quantity && !customAttrs) {
                setError(new client.ApolloError({
                    errorMessage: "Must provide at least one of the parameters: quantity, customAttrs"
                }));
                return;
            }
            const result = yield mutate({
                variables: {
                    input: {
                        cartId,
                        entryId,
                        quantity,
                        customAttrs
                    },
                    cartHint: {
                        storeKey,
                        distributionChannel
                    }
                }
            });
            if (result.errors && result.errors.length > 0) {
                setError(new client.ApolloError({
                    graphQLErrors: result.errors
                }));
            } else {
                setError(undefined);
            }
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCart;
        }));
        return [ updateCart, data === null || data === void 0 ? void 0 : data.updateCart, loading, error ];
    }
    /**
   * React HOC for updating a cart entry.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Update Cart" form.
   * function UpdateCartForm({ updateCart, loading, result, error }: UpdateCartItemProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     updateCart({
   *       entryId,
   *       quantity,
   *       customAttrs,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Update Cart" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedUpdateCartForm = withUpdateCartItem(UpdateCartForm);
   *
   * // Use the enhanced component.
   * <EnhancedUpdateCartForm cartId={cartId} />
   * ~~~
   *
   * @category Cart
   */    function withUpdateCartItem(Component) {
        return _a => {
            var {cartId, storeKey, distributionChannel} = _a, props = __rest(_a, [ "cartId", "storeKey", "distributionChannel" ]);
            const [updateCart, result, loading, error] = useUpdateCartItem({
                cartId,
                storeKey,
                distributionChannel
            });
            return React__default["default"].createElement(Component, Object.assign({
                updateCart,
                loading,
                result,
                error
            }, props));
        };
    }
    const ADDRESS_FRAGMENT = client.gql`
  fragment AddressFragment on Address {
    id
    firstName
    middleName
    lastName
    streetAddress
    additionalStreetInfo
    company
    postalCode
    city
    state
    country
    billingAddress
    shippingAddress
    readOnly
    phone
  }
`;
    const GET_CURRENT_CUSTOMER_ADDRESS_GROUP = client.gql`
  query CurrentCustomerAddressGroup {
    getCurrentCustomerAddressGroup {
      id
      addresses {
        ...AddressFragment
      }
      defaultShippingAddress {
        ...AddressFragment
      }
      defaultBillingAddress {
        ...AddressFragment
      }
    }
  }

  ${ADDRESS_FRAGMENT}
`;
    const ORDER_FRAGMENT = client.gql`
  fragment OrderFragment on Order {
    id
    orderNumber
    draft
    status
    paymentState
    shipmentState
    creationDate
    shipMethod
    paymentMethodId
    shippingAddress {
      ...AddressFragment
    }
    billingAddress {
      ...AddressFragment
    }
    totalAmount {
      ...MoneyAmountFragment
    }
    shipAmount {
      ...MoneyAmountFragment
    }
    taxAmount {
      ...MoneyAmountFragment
    }
    orderItems {
      id
      type
      status
      quantity
      unitPrice {
        moneyAmounts {
          ...MoneyAmountFragment
        }
      }
      totalPrice {
        moneyAmounts {
          ...MoneyAmountFragment
        }
      }
      item {
        ... on Item {
          ...ItemFragment
        }
        ... on ItemVariant {
          ...ItemVariantFragment
        }
      }
    }
    discounts {
      ...DiscountFragment
    }
    discountCodes {
      ...DiscountCodeFragment
    }
    email
  }

  ${ADDRESS_FRAGMENT}
  ${MONEY_AMOUNT_FRAGMENT}
  ${ITEM_FRAGMENT}
  ${ITEM_VARIANT_FRAGMENT}
  ${DISCOUNT_FRAGMENT}
  ${DISCOUNT_CODE_FRAGMENT}
`;
    const FIND_ORDERS = client.gql`
  query Orders($offset: Int, $limit: Int, $sortFields: String, $queryHint: QueryHintInput) {
    findOrders(offset: $offset, limit: $limit, sortFields: $sortFields, queryHint: $queryHint) {
      offset
      limit
      count
      total
      orders {
        ...OrderFragment
      }
      queryHint {
        cursor
      }
    }
  }

  ${ORDER_FRAGMENT}
`;
    const GET_ORDER_BY_ID = client.gql`
  query Order($id: String!) {
    getOrderById(id: $id) {
      ...OrderFragment
    }
  }

  ${ORDER_FRAGMENT}
`;
    const GET_ORDER_BY_ORDER_NUMBER = client.gql`
  query OrderByOrderNumber($orderNumber: String!) {
    getOrderByOrderNumber(orderNumber: $orderNumber) {
      ...OrderFragment
    }
  }

  ${ORDER_FRAGMENT}
`;
    const GET_ORDER_SHIPMENT_METHODS = client.gql`
  query OrderShipmentMethods($id: String!) {
    getOrderShipmentMethods(id: $id) {
      id
      name
      description
      cost {
        moneyAmounts {
          ...MoneyAmountFragment
        }
      }
    }
  }

  ${MONEY_AMOUNT_FRAGMENT}
`;
    const ORDER_DRAFT_FRAGMENT = client.gql`
  fragment OrderDraftFragment on Order {
    id
    status
    draft
    creationDate
    shipMethod
    shippingAddress {
      ...AddressFragment
    }
    billingAddress {
      ...AddressFragment
    }
    totalAmount {
      ...MoneyAmountFragment
    }
  }

  ${ADDRESS_FRAGMENT}
  ${MONEY_AMOUNT_FRAGMENT}
`;
    const SET_ORDER_DETAILS = client.gql`
  mutation SetOrderDetails($input: SetOrderDetailsInput!) {
    setOrderDetails(setOrderDetailsInput: $input) {
      code
      success
      message
      order {
        ...OrderDraftFragment
      }
    }
  }

  ${ORDER_DRAFT_FRAGMENT}
`;
    const CHECK_OUT = client.gql`
  mutation CheckOut($cartId: String!, $cartHint: CartHintInput) {
    checkOut(cartId: $cartId, cartHint: $cartHint) {
      code
      success
      message
      order {
        ...OrderDraftFragment
      }
    }
  }

  ${ORDER_DRAFT_FRAGMENT}
`;
    const FEDERATED_CHECK_OUT = client.gql`
  mutation FederatedCheckOut($cartId: String!) {
    checkOut(cartId: $cartId) {
      code
      success
      message
      order {
        id
        federatedCheckoutUrl
      }
    }
  }
`;
    const PLACE_ORDER = client.gql`
  mutation PlaceOrder($id: String!, $orderNumber: String) {
    placeOrder(id: $id, orderNumber: $orderNumber) {
      code
      success
      message
      order {
        ...OrderFragment
      }
    }
  }

  ${ORDER_FRAGMENT}
`
    /**
   * Custom Hook to start a checkout.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [checkOut, result, loading, error] = useCheckOut({ cartId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle button click
   * const handleButtonClick = () => {
   *   checkOut();
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `checkOut`: A function to trigger the `checkOut` mutation from your UI.
   *   The function returns a promise that fulfills with [[`CheckOut_checkOut | CheckOutResponse`]].
   * - `result`: The [[`CheckOut_checkOut | CheckOutResponse`]] returned from your mutation.
   *   It contains an [[`OrderDraftFragment | OrderDraft`]] you can use in the checkout process.
   *   Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */;
    function useCheckOut({cartId, storeKey}) {
        const [mutate, {loading, data, error}] = client.useMutation(CHECK_OUT, {
            variables: {
                cartId,
                cartHint: {
                    storeKey
                }
            }
        });
        const checkOut = () => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate();
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.checkOut;
        }));
        return [ checkOut, data === null || data === void 0 ? void 0 : data.checkOut, loading, error ];
    }
    /**
   * React HOC for starting a checkout.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "Check Out" button.
   * function CheckOutButton({ checkOut, loading, result, error }: CheckOutProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     checkOut();
   *   }
   *
   *   return (
   *     // renders the "Check Out" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedCheckOutButton = withCheckOut(CheckOutButton);
   *
   * // Use the enhanced component.
   * <EnhancedCheckOutButton cartId={cartId} />
   * ~~~
   *
   * @category Cart
   */    function withCheckOut(Component) {
        return _a => {
            var {cartId, storeKey} = _a, props = __rest(_a, [ "cartId", "storeKey" ]);
            const [checkOut, result, loading, error] = useCheckOut({
                cartId,
                storeKey
            });
            return React__default["default"].createElement(Component, Object.assign({
                checkOut,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Some commerce providers (e.g. Shopify) prefer to use their own ("federated") payment processing systems and
   * checkout pages. In order to share the customer and cart information with such checkout pages,
   * you can use this custom Hook to start a "federated checkout".
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [checkOut, result, loading, error] = useFederatedCheckOut({ cartId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle button click
   * const handleButtonClick = () => {
   *   checkOut();
   * }
   *
   * if (result?.success && result.order?.federatedCheckoutUrl) {
   *   // Redirect the user to the `federatedCheckoutUrl`
   * }
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `checkOut`: A function to trigger the `checkOut` mutation from your UI.
   *   The function returns a promise that fulfills with [[`FederatedCheckOut_checkOut | FederatedCheckOutResponse`]].
   * - `result`: The [[`FederatedCheckOut_checkOut | FederatedCheckOutResponse`]] returned from your mutation.
   *   It contains an [[`FederatedCheckOut_checkOut_order.federatedCheckoutUrl | federatedCheckoutUrl`]]
   *   you can use to redirect the user to the "federated" (hosted by the commerce provider) checkout page.
   *   Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */    function useFederatedCheckOut({cartId}) {
        const [mutate, {loading, data, error}] = client.useMutation(FEDERATED_CHECK_OUT, {
            variables: {
                cartId
            }
        });
        const checkOut = () => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate();
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.checkOut;
        }));
        return [ checkOut, data === null || data === void 0 ? void 0 : data.checkOut, loading, error ];
    }
    /**
   * Some commerce providers (e.g. Shopify) prefer to use their own ("federated") payment processing systems and
   * checkout pages. In order to share the customer and cart information with such checkout pages,
   * you can use this React HOC to start a "federated checkout".
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "Check Out" button.
   * function CheckOutButton({ checkOut, loading, result, error }: FederatedCheckOutProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     checkOut();
   *   }
   *
   *   if (result?.success && result.order?.federatedCheckoutUrl) {
   *     // Redirect the user to the `federatedCheckoutUrl`
   *   }
   *
   *   return (
   *     // renders the "Check Out" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedCheckOutButton = withCheckOut(CheckOutButton);
   *
   * // Use the enhanced component.
   * <EnhancedCheckOutButton cartId={cartId} />
   * ~~~
   *
   * @category Cart
   */    function withFederatedCheckOut(Component) {
        return _a => {
            var {cartId} = _a, props = __rest(_a, [ "cartId" ]);
            const [checkOut, result, loading, error] = useFederatedCheckOut({
                cartId
            });
            return React__default["default"].createElement(Component, Object.assign({
                checkOut,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to apply discounts to the cart.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [applyCartDiscount, result, loading, error] = useApplyCartDiscount({ cartId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   applyCartDiscount({ discountCodes });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `applyCartDiscount`: A function to trigger the `updateCart` mutation from your UI.
   *   You can pass [[`ApplyCartDiscountParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`UpdateCart_updateCart | UpdateCartResponse`]].
   * - `result`: The [[`UpdateCart_updateCart | UpdateCartResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */    function useApplyCartDiscount({cartId, storeKey}) {
        const [mutate, {data, loading, error}] = client.useMutation(UPDATE_CART);
        const updateCart = ({discountCodes}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    input: {
                        cartId,
                        discountCodes
                    },
                    cartHint: {
                        storeKey
                    }
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCart;
        }));
        return [ updateCart, data === null || data === void 0 ? void 0 : data.updateCart, loading, error ];
    }
    /**
   * React HOC for applying discounts to the cart.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Apply Discounts" form.
   * function ApplyDiscountsForm({ applyCartDiscount, loading, result, error }: ApplyCartDiscountProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     applyCartDiscount({ discountCodes });
   *   }
   *
   *   return (
   *     // renders the "Apply Discounts" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedApplyDiscountsForm = withApplyCartDiscount(ApplyDiscountsForm);
   *
   * // Use the enhanced component.
   * <EnhancedApplyDiscountsForm cartId={cartId} />
   * ~~~
   *
   * @category Cart
   */    function withApplyCartDiscount(Component) {
        return _a => {
            var {cartId, storeKey} = _a, props = __rest(_a, [ "cartId", "storeKey" ]);
            const [updateCart, result, loading, error] = useApplyCartDiscount({
                cartId,
                storeKey
            });
            return React__default["default"].createElement(Component, Object.assign({
                applyCartDiscount: updateCart,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to remove discounts from cart.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [removeCartDiscount, result, loading, error] = useRemoveCartDiscount({ cartId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle "Remove Discounts" button click
   * const handleButtonClick = () => {
   *   removeCartDiscount({ discountCodes });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `removeCartDiscount`: A function to trigger the `removeFromCart` mutation from your UI.
   *   You can pass [[`RemoveCartDiscountParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`RemoveFromCart_removeFromCart | RemoveFromCartResponse`]].
   * - `result`: The [[`RemoveFromCart_removeFromCart | RemoveFromCartResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */    function useRemoveCartDiscount({cartId, storeKey}) {
        const [mutate, {data, loading, error}] = client.useMutation(REMOVE_FROM_CART);
        const removeFromCart = ({discountCodes}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    input: {
                        cartId,
                        discountCodes
                    },
                    cartHint: {
                        storeKey
                    }
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.removeFromCart;
        }));
        return [ removeFromCart, data === null || data === void 0 ? void 0 : data.removeFromCart, loading, error ];
    }
    /**
   * React HOC for removing discounts from cart.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Remove Cart Discounts" button.
   * function RemoveCartDiscountsButton({ removeCartDiscount, loading, result, error }: RemoveCartDiscountProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     removeCartDiscount({ discountCodes });
   *   }
   *
   *   return (
   *     // renders the "Remove Cart Discounts" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedRRemoveCartDiscountsButton = withRemoveCartDiscount(RemoveCartDiscountsButton);
   *
   * // Use the enhanced component.
   * <EnhancedRemoveCartDiscountsButton cartId={cartId} />
   * ~~~
   *
   * @category Cart
   */    function withRemoveCartDiscount(Component) {
        return _a => {
            var {cartId, storeKey} = _a, props = __rest(_a, [ "cartId", "storeKey" ]);
            const [removeFromCart, result, loading, error] = useRemoveCartDiscount({
                cartId,
                storeKey
            });
            return React__default["default"].createElement(Component, Object.assign({
                removeCartDiscount: removeFromCart,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to crete a cart.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [createCart, result, loading, error] = createToCart({ storeKey });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle "Create Cart" operation
   * const handleCreateCart = () => {
   *   createCart({
   *     currency,
   *     country,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `createCart`: A function to trigger the `createCart` mutation from your UI.
   *   You can pass [[`CreateCartParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`CreateCart_createToCart | CreateCartResult`]].
   * - `result`: The [[`CreateCart_createCart | CreateCartResult`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */    function useCreateCart({storeKey, distributionChannel}) {
        const [mutate, {data, loading, error}] = client.useMutation(CREATE_CART);
        const createCart = params => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const {currency, country, customerEmail, oldCartId} = params;
            const result = yield mutate({
                variables: {
                    createCartInput: {
                        currency,
                        country,
                        customerEmail,
                        oldCartId
                    },
                    cartHint: {
                        storeKey,
                        distributionChannel
                    }
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.createCart;
        }));
        return [ createCart, data === null || data === void 0 ? void 0 : data.createCart, loading, error ];
    }
    /**
   * React HOC for creating cart.
   * Example usage:
   *
   * ~~~typescript
   * export function CreateCartButton({ currency, country }: CreateCartButtonProps) {
   *   const [createCart, result, loading, error] = useCreateCart({});
   *
   *   const handleOnClick = async () => {
   *     const res = await createCart({ currency, country });
   *     if (res?.success) {
   *       setCartIdInSession(res?.cart?.id)
   *     }
   *   };
   *
   *   return (
   *     // renders the "CreateCart" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedCreateCartButton = withCreateCart(CreateCartButton);
   *
   * // Use the enhanced component.
   * <EnhancedCreatCartButton />
   * ~~~
   *
   * @category Cart
   */    function withCreateCart(Component) {
        return _a => {
            var {storeKey, distributionChannel} = _a, props = __rest(_a, [ "storeKey", "distributionChannel" ]);
            const [createCart, result, loading, error] = useCreateCart({
                storeKey,
                distributionChannel
            });
            return React__default["default"].createElement(Component, Object.assign({
                createCart,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to remove a cart.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [removeCart, result, loading, error] = useRemoveCart({ cartId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   removeCart(cartId);
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `removeCart`: A function to trigger the `removeCart` mutation from your UI.
   *   You can pass [[`RemoveCartParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`RemoveCart_removeCart | RemoveCartResponse`]].
   * - `result`: The [[`RemoveCart_removeCart | RemoveCartResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Cart
   */    function useRemoveCart({cartId: cartIdInput, storeKey, distributionChannel}) {
        const [error, setError] = React.useState();
        const [mutate, {data, loading}] = client.useMutation(REMOVE_CART);
        const removeCart = ({cartId}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    cartId: cartId !== null && cartId !== void 0 ? cartId : cartIdInput,
                    cartHint: {
                        storeKey,
                        distributionChannel
                    }
                }
            });
            if (result.errors && result.errors.length > 0) {
                setError(new client.ApolloError({
                    graphQLErrors: result.errors
                }));
            } else {
                setError(undefined);
            }
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.removeCart;
        }));
        return [ removeCart, data === null || data === void 0 ? void 0 : data.removeCart, loading, error ];
    }
    /**
   * React HOC for deleting a cart.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Remove Cart" form.
   * export function RemoveCartButton({ cartId }: RemoveCartButtonProps) {
   *   const [removeCart, result, loading, error] = useRemoveCart({ cartId });
   *
   *   const handleOnClick = async () => {
   *     const res = await removeCart({ cartId });
   *     if (res?.success) {
   *       setCartIdInSession(undefined)
   *     }
   *   };
   *   return (
   *     // refresh the cart page
   *   );
   * }
   *
   * @category Cart
   */    function withRemoveCart(Component) {
        return _a => {
            var {cartId, storeKey, distributionChannel} = _a, props = __rest(_a, [ "cartId", "storeKey", "distributionChannel" ]);
            const [removeCart, result, loading, error] = useRemoveCart({
                cartId,
                storeKey,
                distributionChannel
            });
            return React__default["default"].createElement(Component, Object.assign({
                removeCart,
                loading,
                result,
                error
            }, props));
        };
    }
    const ADD_CURRENT_CUSTOMER_ADDRESS = client.gql`
  mutation AddCurrentCustomerAddress($addressInput: AddressInput!) {
    addCurrentCustomerAddress(addressInput: $addressInput) {
      success
      message
      address {
        ...AddressFragment
      }
    }
  }

  ${ADDRESS_FRAGMENT}
`;
    const UPDATE_CURRENT_CUSTOMER_ADDRESS = client.gql`
  mutation UpdateCurrentCustomerAddress($addressInput: AddressInput!) {
    updateCurrentCustomerAddress(addressInput: $addressInput) {
      success
      message
      address {
        ...AddressFragment
      }
    }
  }

  ${ADDRESS_FRAGMENT}
`;
    const REMOVE_CURRENT_CUSTOMER_ADDRESS = client.gql`
  mutation RemoveCurrentCustomerAddress($addressId: String!) {
    removeCurrentCustomerAddress(addressId: $addressId) {
      success
      message
      address {
        ...AddressFragment
      }
    }
  }

  ${ADDRESS_FRAGMENT}
`;
    const SET_CURRENT_CUSTOMER_DEFAULT_SHIPPING_ADDRESS = client.gql`
  mutation CurrentCustomerDefaultShippingAddress($addressId: String!) {
    setCurrentCustomerDefaultShippingAddress(addressId: $addressId) {
      success
      message
      address {
        ...AddressFragment
      }
    }
  }

  ${ADDRESS_FRAGMENT}
`;
    const SET_CURRENT_CUSTOMER_DEFAULT_BILLING_ADDRESS = client.gql`
  mutation CurrentCustomerDefaultBillingAddress($addressId: String!) {
    setCurrentCustomerDefaultBillingAddress(addressId: $addressId) {
      success
      message
      address {
        ...AddressFragment
      }
    }
  }

  ${ADDRESS_FRAGMENT}
`
    /**
   * Custom Hook to add an address.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [addAddress, result, loading, error] = useAddAddress();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   addAddress({
   *     firstName,
   *     middleName,
   *     lastName,
   *     company,
   *     country,
   *     city,
   *     state,
   *     postalCode,
   *     streetAddress,
   *     additionalStreetInfo,
   *     billingAddress,
   *     shippingAddress,
   *     readOnly: false,
   *     phone,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `addAddress`: A function to trigger the `addCurrentCustomerAddress` mutation from your UI.
   *   You can pass [[`AddAddressParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`AddCurrentCustomerAddress_addCurrentCustomerAddress | AddAddressResponse`]].
   * - `result`: The [[`AddCurrentCustomerAddress_addCurrentCustomerAddress | AddAddressResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Address
   */;
    function useAddAddress() {
        const [mutate, {data, loading, error}] = client.useMutation(ADD_CURRENT_CUSTOMER_ADDRESS, {
            update(cache, {data}) {
                var _a;
                if (!(data === null || data === void 0 ? void 0 : data.addCurrentCustomerAddress.address)) {
                    return;
                }
                const results = cache.readQuery({
                    query: GET_CURRENT_CUSTOMER_ADDRESS_GROUP
                });
                if (results === null || results === void 0 ? void 0 : results.getCurrentCustomerAddressGroup) {
                    cache.writeQuery({
                        query: GET_CURRENT_CUSTOMER_ADDRESS_GROUP,
                        data: {
                            getCurrentCustomerAddressGroup: Object.assign(Object.assign({}, results.getCurrentCustomerAddressGroup), {
                                addresses: [ ...(_a = results.getCurrentCustomerAddressGroup.addresses) !== null && _a !== void 0 ? _a : [], data.addCurrentCustomerAddress.address ]
                            })
                        }
                    });
                }
            }
        });
        const addAddress = React.useCallback(params => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    addressInput: Object.assign({}, params)
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.addCurrentCustomerAddress;
        })), [ mutate ]);
        return [ addAddress, data === null || data === void 0 ? void 0 : data.addCurrentCustomerAddress, loading, error ];
    }
    /**
   * React HOC for adding address.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Add address" form.
   * function AddAddressForm({ addAddress, loading, result, error }: AddAddressProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     addAddress({
   *       firstName,
   *       middleName,
   *       lastName,
   *       company,
   *       country,
   *       city,
   *       state,
   *       postalCode,
   *       streetAddress,
   *       additionalStreetInfo,
   *       billingAddress,
   *       shippingAddress,
   *       readOnly: false,
   *       phone,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Add address" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedAddAddressForm = withAddAddress(AddAddressForm);
   *
   * // Use the enhanced component.
   * <EnhancedAddAddressForm />
   * ~~~
   *
   * @category Address
   */    function withAddAddress(Component) {
        return props => {
            const [addAddress, result, loading, error] = useAddAddress();
            return React__default["default"].createElement(Component, Object.assign({
                addAddress,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook for fetching addresses.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [addressGroup, loading, error] = useAddressGroup();
   * ~~~
   *
   * @param [[`AddressGroupInputProps`]]
   * @returns An array constitutes of the following:
   * - `addressGroup`: An object containing the
   *   [[`CurrentCustomerAddressGroup_getCurrentCustomerAddressGroup | AddressGroupResult`]] result.
   *   Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Address
   */    function useAddressGroup(inputProps) {
        var _a;
        const customQueryOptionsProcessor = inputProps === null || inputProps === void 0 ? void 0 : inputProps.customQueryOptionsProcessor;
        const {loading, data, error} = useQueryCustom(GET_CURRENT_CUSTOMER_ADDRESS_GROUP, undefined, customQueryOptionsProcessor);
        return [ (_a = data === null || data === void 0 ? void 0 : data.getCurrentCustomerAddressGroup) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for fetching addresses.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders addresses.
   * function AddressGroup({ loading, addressGroup, error }: AddressGroupProps) {
   *   return (
   *     // renders addresses
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedAddressGroup = withAddressGroup(AddressGroup);
   *
   * // Use the enhanced component.
   * <EnhancedAddressGroup />
   * ~~~
   *
   * @category Address
   */    function withAddressGroup(Component) {
        return props => {
            const [result, loading, error] = useAddressGroup();
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                addressGroup: result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to remove an address.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [removeAddress, result, loading, error] = useRemoveAddress();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle button click
   * const handleClick = () => {
   *   removeAddress({ addressId });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `removeAddress`:
   *   A function to trigger the `removeCurrentCustomerAddress` mutation from your UI.
   *   You can pass [[`RemoveAddressParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`RemoveCurrentCustomerAddress_removeCurrentCustomerAddress | RemoveAddressResponse`]].
   * - `result`:
   *   The [[`RemoveCurrentCustomerAddress_removeCurrentCustomerAddress | RemoveAddressResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Address
   */    function useRemoveAddress() {
        var _a;
        const [mutate, {data, loading, error}] = client.useMutation(REMOVE_CURRENT_CUSTOMER_ADDRESS, {
            update(cache, {data}) {
                var _a, _b, _c, _d;
                if (!(data === null || data === void 0 ? void 0 : data.removeCurrentCustomerAddress.address)) {
                    return;
                }
                const results = cache.readQuery({
                    query: GET_CURRENT_CUSTOMER_ADDRESS_GROUP
                });
                const addressGroup = results === null || results === void 0 ? void 0 : results.getCurrentCustomerAddressGroup;
                if (addressGroup === null || addressGroup === void 0 ? void 0 : addressGroup.addresses) {
                    cache.writeQuery({
                        query: GET_CURRENT_CUSTOMER_ADDRESS_GROUP,
                        data: {
                            getCurrentCustomerAddressGroup: Object.assign(Object.assign({}, addressGroup), {
                                addresses: addressGroup.addresses.filter(addr => {
                                    var _a;
                                    return (addr === null || addr === void 0 ? void 0 : addr.id) !== ((_a = data.removeCurrentCustomerAddress.address) === null || _a === void 0 ? void 0 : _a.id);
                                }),
                                defaultShippingAddress: ((_a = addressGroup.defaultShippingAddress) === null || _a === void 0 ? void 0 : _a.id) === ((_b = data.removeCurrentCustomerAddress.address) === null || _b === void 0 ? void 0 : _b.id) ? null : addressGroup.defaultShippingAddress,
                                defaultBillingAddress: ((_c = addressGroup.defaultBillingAddress) === null || _c === void 0 ? void 0 : _c.id) === ((_d = data.removeCurrentCustomerAddress.address) === null || _d === void 0 ? void 0 : _d.id) ? null : addressGroup.defaultBillingAddress
                            })
                        }
                    });
                }
            }
        });
        const removeAddress = params => __awaiter(this, void 0, void 0, (function*() {
            var _b;
            const result = yield mutate({
                variables: Object.assign({}, params)
            });
            return (_b = result.data) === null || _b === void 0 ? void 0 : _b.removeCurrentCustomerAddress;
        }));
        return [ removeAddress, (_a = data === null || data === void 0 ? void 0 : data.removeCurrentCustomerAddress) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for removing an address.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "Remove address" button.
   * function RemoveAddressButton({ removeAddress, loading, result, error }: RemoveAddressProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleClick = () => {
   *     removeAddress({ addressId });
   *   }
   *
   *   return (
   *     // renders the "Remove address" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedRemoveAddressButton = withRemoveAddress(RemoveAddressButton);
   *
   * // Use the enhanced component.
   * <EnhancedRemoveAddressButton />
   * ~~~
   *
   * @category Address
   */    function withRemoveAddress(Component) {
        return props => {
            const [removeAddress, result, loading, error] = useRemoveAddress();
            return React__default["default"].createElement(Component, Object.assign({
                removeAddress,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to set the default billing address.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [setDefaultBillingAddress, result, loading, error] = useSetDefaultBillingAddress();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle button click
   * const handleClick = () => {
   *   setDefaultBillingAddress({ addressId });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `setDefaultBillingAddress`:
   *   A function to trigger the `setCurrentCustomerDefaultBillingAddress`
   *   mutation from your UI. You can pass [[`SetDefaultBillingAddressParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`CurrentCustomerDefaultBillingAddress_setCurrentCustomerDefaultBillingAddress | SetDefaultBillingAddressResponse`]].
   * - `result`:
   *   The
   *   [[`CurrentCustomerDefaultBillingAddress_setCurrentCustomerDefaultBillingAddress | SetDefaultBillingAddressResponse`]]
   *   returned from your mutation. Defaults to undefined
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Address
   */    function useSetDefaultBillingAddress() {
        var _a;
        const [mutate, {data, loading, error}] = client.useMutation(SET_CURRENT_CUSTOMER_DEFAULT_BILLING_ADDRESS, {
            update(cache, {data}) {
                if (data === null || data === void 0 ? void 0 : data.setCurrentCustomerDefaultBillingAddress.address) {
                    const results = cache.readQuery({
                        query: GET_CURRENT_CUSTOMER_ADDRESS_GROUP
                    });
                    if (results === null || results === void 0 ? void 0 : results.getCurrentCustomerAddressGroup) {
                        cache.writeQuery({
                            query: GET_CURRENT_CUSTOMER_ADDRESS_GROUP,
                            data: {
                                getCurrentCustomerAddressGroup: Object.assign(Object.assign({}, results.getCurrentCustomerAddressGroup), {
                                    defaultBillingAddress: data.setCurrentCustomerDefaultBillingAddress.address
                                })
                            }
                        });
                    }
                }
            }
        });
        const setDefaultBillingAddress = params => __awaiter(this, void 0, void 0, (function*() {
            var _b;
            const result = yield mutate({
                variables: Object.assign({}, params)
            });
            return (_b = result.data) === null || _b === void 0 ? void 0 : _b.setCurrentCustomerDefaultBillingAddress;
        }));
        return [ setDefaultBillingAddress, (_a = data === null || data === void 0 ? void 0 : data.setCurrentCustomerDefaultBillingAddress) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for setting the default billing address.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "SetDefaultBillingAddress" form.
   * function SetDefaultBillingAddressForm({ setDefaultBillingAddress, loading, result, error }: SetDefaultBillingAddressProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     setDefaultBillingAddress({ addressId });
   *   }
   *
   *   return (
   *     // renders the form to set default billing address
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedSetDefaultBillingAddressForm = withSetDefaultBillingAddress(SetDefaultBillingAddressForm);
   *
   * // Use the enhanced component.
   * <EnhancedSetDefaultBillingAddressForm />
   * ~~~
   *
   * @category Address
   */    function withSetDefaultBillingAddress(Component) {
        return props => {
            const [setDefaultBillingAddress, result, loading, error] = useSetDefaultBillingAddress();
            return React__default["default"].createElement(Component, Object.assign({
                setDefaultBillingAddress,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to set the default shipping address.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [setDefaultShippingAddress, result, loading, error] = useSetDefaultShippingAddress();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle button click
   * const handleClick = () => {
   *   setDefaultShippingAddress({ addressId });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `setDefaultShippingAddress`:
   *   A function to trigger the `setCurrentCustomerDefaultShippingAddress`
   *   mutation from your UI. You can pass [[`SetDefaultShippingAddressParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`CurrentCustomerDefaultShippingAddress_setCurrentCustomerDefaultShippingAddress | SetDefaultShippingAddressResponse`]].
   * - `result`:
   *   The
   *   [[`CurrentCustomerDefaultShippingAddress_setCurrentCustomerDefaultShippingAddress | SetDefaultShippingAddressResponse`]]
   *   returned from your mutation. Defaults to undefined
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Address
   */    function useSetDefaultShippingAddress() {
        var _a;
        const [mutate, {data, loading, error}] = client.useMutation(SET_CURRENT_CUSTOMER_DEFAULT_SHIPPING_ADDRESS, {
            update(cache, {data}) {
                if (data === null || data === void 0 ? void 0 : data.setCurrentCustomerDefaultShippingAddress.address) {
                    const results = cache.readQuery({
                        query: GET_CURRENT_CUSTOMER_ADDRESS_GROUP
                    });
                    if (results === null || results === void 0 ? void 0 : results.getCurrentCustomerAddressGroup) {
                        cache.writeQuery({
                            query: GET_CURRENT_CUSTOMER_ADDRESS_GROUP,
                            data: {
                                getCurrentCustomerAddressGroup: Object.assign(Object.assign({}, results.getCurrentCustomerAddressGroup), {
                                    defaultShippingAddress: data.setCurrentCustomerDefaultShippingAddress.address
                                })
                            }
                        });
                    }
                }
            }
        });
        const setDefaultShippingAddress = params => __awaiter(this, void 0, void 0, (function*() {
            var _b;
            const result = yield mutate({
                variables: Object.assign({}, params)
            });
            return (_b = result.data) === null || _b === void 0 ? void 0 : _b.setCurrentCustomerDefaultShippingAddress;
        }));
        return [ setDefaultShippingAddress, (_a = data === null || data === void 0 ? void 0 : data.setCurrentCustomerDefaultShippingAddress) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for setting the default shipping address.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "SetDefaultShippingAddress" form.
   * function SetDefaultShippingAddressForm({ setDefaultShippingAddress, loading, result, error }: SetDefaultShippingAddressProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     setDefaultShippingAddress({ addressId });
   *   }
   *
   *   return (
   *     // renders the form to set default shipping address
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedSetDefaultShippingAddressForm = withSetDefaultShippingAddress(SetDefaultShippingAddressForm);
   *
   * // Use the enhanced component.
   * <EnhancedSetDefaultShippingAddressForm />
   * ~~~
   *
   * @category Address
   */    function withSetDefaultShippingAddress(Component) {
        return props => {
            const [setDefaultShippingAddress, result, loading, error] = useSetDefaultShippingAddress();
            return React__default["default"].createElement(Component, Object.assign({
                setDefaultShippingAddress,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to update an address.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [updateAddress, result, loading, error] = useUpdateAddress({ addressId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   updateAddress({
   *     firstName,
   *     middleName,
   *     lastName,
   *     company,
   *     country,
   *     city,
   *     state,
   *     postalCode,
   *     streetAddress,
   *     additionalStreetInfo,
   *     billingAddress,
   *     shippingAddress,
   *     readOnly,
   *     phone
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `updateAddress`: A function to trigger the
   *   `updateCurrentCustomerAddress` mutation from your UI.
   *   You can pass [[`UpdateAddressParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`UpdateCurrentCustomerAddress_updateCurrentCustomerAddress | UpdateAddressResponse`]].
   * - `result`: The [[`UpdateCurrentCustomerAddress_updateCurrentCustomerAddress | UpdateAddressResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Address
   */    function useUpdateAddress({addressId}) {
        const [mutate, {data, loading, error}] = client.useMutation(UPDATE_CURRENT_CUSTOMER_ADDRESS);
        const updateAddress = params => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    addressInput: Object.assign(Object.assign({}, params), {
                        id: addressId
                    })
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCurrentCustomerAddress;
        }));
        return [ updateAddress, data === null || data === void 0 ? void 0 : data.updateCurrentCustomerAddress, loading, error ];
    }
    /**
   * React HOC for updating an address.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Update address" form.
   * function UpdateAddressForm({ updateAddress, loading, result, error }: UpdateAddressProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     updateAddress({
   *       firstName,
   *       middleName,
   *       lastName,
   *       company,
   *       country,
   *       city,
   *       state,
   *       postalCode,
   *       streetAddress,
   *       additionalStreetInfo,
   *       billingAddress,
   *       shippingAddress,
   *       readOnly,
   *       phone,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Update address" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedUpdateAddressForm = withUpdateAddress(UpdateAddressForm);
   *
   * // Use the enhanced component.
   * <EnhancedUpdateAddressForm addressId={addressId} />
   * ~~~
   *
   * @category Address
   */    function withUpdateAddress(Component) {
        return props => {
            const {addressId} = props;
            const [updateAddress, result, loading, error] = useUpdateAddress({
                addressId
            });
            return React__default["default"].createElement(Component, Object.assign({
                updateAddress,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook for fetching current customer.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [currentCustomer, loading, error] = useCurrentCustomer();
   * ~~~
   *
   * @param [[`CurrentCustomerInputProps`]]
   * @returns An array constitutes of the following:
   * - `currentCustomer`: An object containing the [[`CurrentCustomerResult`]] result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Account
   */    function useCurrentCustomer(inputProps) {
        const customQueryOptionsProcessor = inputProps === null || inputProps === void 0 ? void 0 : inputProps.customQueryOptionsProcessor;
        const {loading, data, error: apolloError} = useQueryCustom(GET_CURRENT_CUSTOMER, undefined, customQueryOptionsProcessor);
        const [result, error] = React.useMemo(() => {
            var _a;
            if (loading) {
                return [ undefined, apolloError ];
            }
            if (data) {
                loggedInVar(!!data.getCurrentCustomer);
                return [ {
                    anonymous: !data.getCurrentCustomer,
                    currentCustomer: (_a = data.getCurrentCustomer) !== null && _a !== void 0 ? _a : undefined
                }, apolloError ];
            }
            return [ undefined, apolloError ];
        }, [ data, loading, apolloError ]);
        return [ result, loading, error ];
    }
    /**
   * React HOC for fetching current customer.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders current customer.
   * function CurrentCustomer({ loading, currentCustomer, error }: CurrentCustomerProps) {
   *   return (
   *     // renders current customer
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedCurrentCustomer = withCurrentCustomer(CurrentCustomer);
   *
   * // Use the enhanced component.
   * <EnhancedCurrentCustomer />
   * ~~~
   *
   * @category Account
   */    function withCurrentCustomer(Component) {
        return props => {
            const [result, loading, error] = useCurrentCustomer();
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                currentCustomer: result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to login a customer.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [login, result, loading, error] = useLogin();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   login({
   *     username,
   *     password,
   *     oldCartId,
   *     mergeWithExistingCustomerCart,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `login`: A function to trigger the login process from your UI. You can pass [[`LoginParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`LoginResult`]].
   * - `result`: The [[`LoginResult`]] returned from your request. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your login request is in flight.
   * - `error`: Any errors returned from the login request.
   *
   * @category Account
   */    function useLogin() {
        const [customer, setCustomer] = React.useState();
        const [cart, setCart] = React.useState();
        const [loading, setLoading] = React.useState(false);
        const [error, setError] = React.useState();
        const {connector = "", graphqlServiceUrl = "", currentToken} = React.useContext(CommerceConnectorContext);
        const client$1 = client.useApolloClient();
        const login = params => __awaiter(this, void 0, void 0, (function*() {
            var _a, _b;
            const {username, password, oldCartId, mergeWithExistingCustomerCart, country, currency, locale, attrs, type} = params;
            setLoading(true);
            try {
                const credentials = {
                    username,
                    password,
                    country,
                    currency,
                    locale,
                    attrs
                };
                if (oldCartId) {
                    credentials.authHint = {
                        oldCartId
                    };
                }
                if (mergeWithExistingCustomerCart) {
                    credentials.authHint = Object.assign(Object.assign({}, credentials.authHint), {
                        mergeWithExistingCustomerCart: "true"
                    });
                }
                if (type === "refresh" && currentToken) {
                    yield auth.refresh(currentToken, graphqlServiceUrl, connector, credentials);
                } else {
                    yield auth.login(credentials, graphqlServiceUrl, connector, currentToken);
                }
                yield client$1.cache.reset();
                const loggedInCustomer = (_a = yield refreshCustomer(client$1)) !== null && _a !== void 0 ? _a : undefined;
                const loggedInCart = (_b = yield refreshCart(client$1)) !== null && _b !== void 0 ? _b : undefined;
                setCustomer(loggedInCustomer);
                setCart(loggedInCart);
                return {
                    customer: loggedInCustomer,
                    cart: loggedInCart
                };
            } catch (err) {
                setError(err);
                return undefined;
            } finally {
                setLoading(false);
            }
        }));
        return [ login, {
            customer,
            cart
        }, loading, error ];
    }
    /**
   * React HOC for logging in a customer.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Login" form.
   * function LoginForm({ login, loading, result, error }: LoginProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     login({
   *       username,
   *       password,
   *       oldCartId,
   *       mergeWithExistingCustomerCart,
   *     });
   *   }
   *
   *   return (
   *     // renders the "login" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedLoginForm = withLogin(LoginForm);
   *
   * // Use the enhanced component.
   * <EnhancedLoginForm />
   * ~~~
   *
   * @category Account
   */    function withLogin(Component) {
        return props => {
            const [login, result, loading, error] = useLogin();
            return React__default["default"].createElement(Component, Object.assign({
                login,
                result,
                loading,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to logout a customer.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [logout, loading, error] = useLogout();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle a button click
   * const handleButtonClick = async () => {
   *   const result = await logout();
   *   // Do something with the result
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `logout`: A function to trigger the logout process from your UI.
   *   The function returns a promise that fulfills with a boolean to indicate whether or not the logout succeeded.
   * - `loading`: A boolean that indicates whether your logout request is in flight.
   * - `error`: Any errors returned from the logout request.
   *
   * @category Account
   */    function useLogout() {
        const [loading, setLoading] = React.useState(false);
        const [error, setError] = React.useState();
        const client$1 = client.useApolloClient();
        const logout = () => __awaiter(this, void 0, void 0, (function*() {
            setLoading(true);
            try {
                auth.logout();
                yield client$1.cache.reset();
                return true;
            } catch (err) {
                setError(err);
                return false;
            } finally {
                setLoading(false);
            }
        }));
        return [ logout, loading, error ];
    }
    /**
   * React HOC for logging out a customer.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Logout" button.
   * function LogoutButton({ logout, loading, error }: LogoutProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = async () => {
   *     const result = await logout();
   *     // Do something with the result
   *   }
   *
   *   return (
   *     // renders the "logout" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedLogoutButton = withLogout(LogoutButton);
   *
   * // Use the enhanced component.
   * <EnhancedLogoutButton />
   * ~~~
   *
   * @category Account
   */    function withLogout(Component) {
        return props => {
            const [logout, loading, error] = useLogout();
            return React__default["default"].createElement(Component, Object.assign({
                logout,
                loading,
                error
            }, props));
        };
    }
    /**
   * A "federated login" usually constitutes three steps:
   * 1. User is redirected to the remote login URL (hosted by the commerce backend) to login;
   * 2. After successful login, the remote server will send a "token" back to a "callback URL" on the frontend;
   * 3. The frontend uses the "token" to login with the GraphQL Service.
   * This is a custom hook to deal with the last step.
   *
   * ~~~typescript
   * // An exmple usage with the hook. Usually this is to be used on the "callback page"
   * const [federatedLogin, result, loading, error] = useFederatedLogin();
   *
   * // A sample `useEffect()` hook to handle login on page load
   * useEffect(() => {
   *   const userId = ...; // Get userId
   *   const token = ...; // Get token
   *   federatedLogin({ userId, token });
   * }, []);
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `federatedLogin`: A function to trigger the GraphQL service login from your UI.
   *   You can pass [[`FederatedLoginParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`FederatedLoginResult`]].
   * - `result`: The [[`FederatedLoginResult`]] returned from your request. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your login request is in flight.
   * - `error`: Any errors returned from the login request.
   *
   * @category Account
   */    function useFederatedLogin() {
        const [customer, setCustomer] = React.useState();
        const [cart, setCart] = React.useState();
        const [loading, setLoading] = React.useState(false);
        const [error, setError] = React.useState();
        const {connector = "", graphqlServiceUrl = "", currentToken} = React.useContext(CommerceConnectorContext);
        const client$1 = client.useApolloClient();
        const federatedLogin = params => __awaiter(this, void 0, void 0, (function*() {
            var _a, _b;
            const {token, userId} = params;
            const attrs = {
                referer: window.location.href
            };
            setLoading(true);
            try {
                yield auth.login({
                    username: userId,
                    password: "",
                    authHint: {
                        token
                    },
                    attrs
                }, graphqlServiceUrl, connector, currentToken);
                const loggedInCustomer = (_a = yield refreshCustomer(client$1)) !== null && _a !== void 0 ? _a : undefined;
                const loggedInCart = (_b = yield refreshCart(client$1)) !== null && _b !== void 0 ? _b : undefined;
                setCustomer(loggedInCustomer);
                setCart(loggedInCart);
                return {
                    customer: loggedInCustomer,
                    cart: loggedInCart
                };
            } catch (err) {
                setError(err);
                return undefined;
            } finally {
                setLoading(false);
            }
        }));
        return [ federatedLogin, {
            customer,
            cart
        }, loading, error ];
    }
    /**
   * A "federated login" usually constitutes three steps:
   * 1. User is redirected to the remote login URL (hosted by the commerce backend) to login;
   * 2. After successful login, the remote server will send a "token" back to a "callback URL" on the frontend;
   * 3. The frontend uses the "token" to login with the GraphQL Service.
   * This is a React HOC for the last step.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "Callback page".
   * function LoginCallback({ federatedLogin, loading, result, error }: FederatedLoginProps) {
   *
   *   // A sample `useEffect()` hook to handle login on page load
   *   useEffect(() => {
   *     const userId = ...; // Get userId
   *     const token = ...; // Get token
   *     federatedLogin({ userId, token });
   *   }, []);
   *
   *   // If login succeeds and a customer object is returned
   *   if (result.customer) {
   *     return (
   *       // Redirect to the protected page
   *     );
   *   }
   *
   *   // Handle any errors
   * }
   *
   * // Enhance the component.
   * const EnhancedLoginCallback = withFederatedLogin(LoginCallback);
   *
   * // Use the enhanced component.
   * <EnhancedLoginCallback />
   * ~~~
   *
   * @category Account
   */    function withFederatedLogin(Component) {
        return props => {
            const [federatedLogin, result, loading, error] = useFederatedLogin();
            return React__default["default"].createElement(Component, Object.assign({
                federatedLogin,
                loading,
                result,
                error
            }, props));
        };
    }
    const SIGN_UP = client.gql`
  mutation SignUp($input: CustomerSignUpInput!) {
    signUp(customerSignUpInput: $input) {
      code
      success
      message
      customer {
        ...CustomerFragment
      }
    }
  }

  ${CUSTOMER_FRAGMENT}
`;
    const UPDATE_CUSTOMER = client.gql`
  mutation UpdateCurrentCustomerDetail($input: CustomerDetailInput!) {
    updateCurrentCustomerDetail(customerDetailInput: $input) {
      code
      success
      message
      customer {
        ...CustomerFragment
      }
    }
  }

  ${CUSTOMER_FRAGMENT}
`;
    const CHANGE_PASSWORD = client.gql`
  mutation ChangeCurrentCustomerPassword($input: CustomerCredsInput!) {
    changeCurrentCustomerPassword(customerCredsInput: $input) {
      code
      success
      message
      customer {
        ...CustomerFragment
      }
    }
  }

  ${CUSTOMER_FRAGMENT}
`;
    const RECOVER_CUSTOMER = client.gql`
  mutation RecoverCustomer($email: String!) {
    recoverCustomer(email: $email) {
      code
      success
      message
    }
  }
`;
    const RESET_CUSTOMER_PASSWORD = client.gql`
  mutation ResetCustomerPassword($input: CustomerResetInput!) {
    resetCustomerPassword(customerResetInput: $input) {
      code
      success
      message
      customer {
        ...CustomerFragment
      }
    }
  }

  ${CUSTOMER_FRAGMENT}
`
    /**
   * Custom Hook to register (sign up) a customer.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [signup, result, loading, error] = useSignup();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   signup({
   *     email,
   *     password,
   *     firstName,
   *     middleName,
   *     lastName,
   *     title,
   *     salutation,
   *     companyName,
   *     dateOfBirth,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `signup`: A function to trigger the `signUp` mutation from your UI.
   *   You can pass [[`SignupParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`SignUp_signUp | SignUpResponse`]].
   * - `result`: The [[`SignUp_signUp | SignUpResponse`]] returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Account
   */;
    function useSignup() {
        var _a;
        const [mutate, {data, loading, error}] = client.useMutation(SIGN_UP);
        const signup = params => __awaiter(this, void 0, void 0, (function*() {
            var _b;
            const result = yield mutate({
                variables: {
                    input: Object.assign({}, params)
                }
            });
            return (_b = result.data) === null || _b === void 0 ? void 0 : _b.signUp;
        }));
        return [ signup, (_a = data === null || data === void 0 ? void 0 : data.signUp) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for registering (signing up) a customer.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Update customer" form.
   * function SignupForm({ signup, loading, result, error }: SignupProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     signup({
   *       email,
   *       password,
   *       firstName,
   *       middleName,
   *       lastName,
   *       title,
   *       salutation,
   *       companyName,
   *       dateOfBirth,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Signup" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedSignupForm = withSignup(SignupForm);
   *
   * // Use the enhanced component.
   * <EnhancedSignupForm />
   * ~~~
   *
   * @category Account
   */    function withSignup(Component) {
        return props => {
            const [signup, result, loading, error] = useSignup();
            return React__default["default"].createElement(Component, Object.assign({
                signup,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to update a customer.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [updateCustomer, result, loading, error] = useUpdateCustomer();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   updateCustomer({
   *     email,
   *     firstName,
   *     middleName,
   *     lastName,
   *     title,
   *     salutation,
   *     companyName,
   *     dateOfBirth,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `updateCustomer`: A function to trigger the `updateCurrentCustomerDetail` mutation from your UI.
   *   You can pass [[`UpdateCustomerParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`UpdateCurrentCustomerDetail_updateCurrentCustomerDetail | UpdateCustomerResponse`]].
   * - `result`: The [[`UpdateCurrentCustomerDetail_updateCurrentCustomerDetail | UpdateCustomerResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Account
   */    function useUpdateCustomer() {
        const [mutate, {data, loading, error}] = client.useMutation(UPDATE_CUSTOMER);
        const updateCustomer = params => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    input: Object.assign({}, params)
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCurrentCustomerDetail;
        }));
        return [ updateCustomer, data === null || data === void 0 ? void 0 : data.updateCurrentCustomerDetail, loading, error ];
    }
    /**
   * React HOC for updating a customer.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Update customer" form.
   * function UpdateCustomerForm({ updateCustomer, loading, result, error }: UpdateCustomerProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     updateCustomer({
   *       email,
   *       firstName,
   *       middleName,
   *       lastName,
   *       title,
   *       salutation,
   *       companyName,
   *       dateOfBirth,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Update customer" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedUpdateCustomerForm = withUpdateCustomer(UpdateCustomerForm);
   *
   * // Use the enhanced component.
   * <EnhancedUpdateCustomerForm />
   * ~~~
   *
   * @category Account
   */    function withUpdateCustomer(Component) {
        return props => {
            const [updateCustomer, result, loading, error] = useUpdateCustomer();
            return React__default["default"].createElement(Component, Object.assign({
                updateCustomer,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to change a customer's password.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [changePassword, result, loading, error] = useChangePassword();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   changePassword({
   *     password,
   *     newPassword,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `changePassword`: A function to trigger the `changeCurrentCustomerPassword` mutation from your UI.
   *   You can pass [[`ChangePasswordParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`ChangeCurrentCustomerPassword_changeCurrentCustomerPassword | ChangePasswordResponse`]].
   * - `result`: The [[`ChangeCurrentCustomerPassword_changeCurrentCustomerPassword | ChangePasswordResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Account
   */    function useChangePassword() {
        const [mutate, {data, loading, error}] = client.useMutation(CHANGE_PASSWORD);
        const changePassword = params => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    input: Object.assign({}, params)
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.changeCurrentCustomerPassword;
        }));
        return [ changePassword, data === null || data === void 0 ? void 0 : data.changeCurrentCustomerPassword, loading, error ];
    }
    /**
   * React HOC for changing a customer's password.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Change password" form.
   * function ChangePasswordForm({ changePassword, loading, result, error }: ChangePasswordProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     changePassword({
   *       password,
   *       newPassword,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Change password" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedChangePasswordForm = withChangePassword(ChangePasswordForm);
   *
   * // Use the enhanced component.
   * <EnhancedChangePasswordForm />
   * ~~~
   *
   * @category Account
   */    function withChangePassword(Component) {
        return props => {
            const [changePassword, result, loading, error] = useChangePassword();
            return React__default["default"].createElement(Component, Object.assign({
                changePassword,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to send a "Reset password" email to the customer, as the first step in the reset password process
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [recoverCustomer, result, loading, error] = useForgotPassword();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   recoverCustomer({ email });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `recoverCustomer`: A function to trigger the `recoverCustomer` mutation from your UI,
   *   which will send a "Reset password" email to the customer's email address if it's valid.
   *   You can pass [[`ForgotPasswordParams`]] as parameters.
   *   The function returns a promise that fulfills with [[`RecoverCustomer_recoverCustomer | RecoverCustomerResult`]].
   * - `result`: The [[`RecoverCustomer_recoverCustomer | RecoverCustomerResult`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Account
   */    function useForgotPassword() {
        const [mutate, {data, loading, error}] = client.useMutation(RECOVER_CUSTOMER);
        const recoverCustomer = params => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: Object.assign({}, params)
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.recoverCustomer;
        }));
        return [ recoverCustomer, data === null || data === void 0 ? void 0 : data.recoverCustomer, loading, error ];
    }
    /**
   * React HOC for sending a "Reset password" email to the customer, as the first step in the reset password process
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Forgot password?" form.
   * function ForgotPasswordForm({ recoverCustomer, loading, result, error }: ForgotPasswordProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     recoverCustomer({ email });
   *   }
   *
   *   return (
   *     // renders the "Forgot password?" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedForgotPasswordForm = withForgotPassword(ForgotPasswordForm);
   *
   * // Use the enhanced component.
   * <EnhancedForgotPasswordForm />
   * ~~~
   *
   * @category Account
   */    function withForgotPassword(Component) {
        return props => {
            const [recoverCustomer, result, loading, error] = useForgotPassword();
            return React__default["default"].createElement(Component, Object.assign({
                recoverCustomer,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to reset a customer's password, using the password reset token/url received in the email.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [resetPassword, result, loading, error] = useResetPassword({ passwordResetToken });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   recoverCustomer({ newPassword });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `resetPassword`: A function to trigger the `resetCustomerPassword` mutation from your UI.
   *   You can pass [[`ResetPasswordParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`ResetCustomerPassword_resetCustomerPassword | ResetCustomerPasswordResponse`]].
   * - `result`: The [[`ResetCustomerPassword_resetCustomerPassword | ResetCustomerPasswordResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Account
   */    function useResetPassword({passwordResetToken}) {
        var _a;
        const [mutate, {data, loading, error}] = client.useMutation(RESET_CUSTOMER_PASSWORD);
        const resetPassword = params => __awaiter(this, void 0, void 0, (function*() {
            var _b;
            const result = yield mutate({
                variables: {
                    input: Object.assign(Object.assign({}, params), {
                        passwordResetToken
                    })
                }
            });
            return (_b = result.data) === null || _b === void 0 ? void 0 : _b.resetCustomerPassword;
        }));
        return [ resetPassword, (_a = data === null || data === void 0 ? void 0 : data.resetCustomerPassword) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for resetting a customer's password, using the password reset token/url received in the email.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Reset password" form.
   * function ResetPasswordForm({ resetPassword, loading, result, error }: ResetPasswordProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     resetPassword({ newPassword });
   *   }
   *
   *   return (
   *     // renders the "Reset password" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedResetPasswordForm = withResetPassword(ResetPasswordForm);
   *
   * // Use the enhanced component.
   * <EnhancedResetPasswordForm passwordResetToken={passwordResetToken} />
   * ~~~
   *
   * @category Account
   */    function withResetPassword(Component) {
        return props => {
            const {passwordResetToken} = props;
            const [resetPassword, result, loading, error] = useResetPassword({
                passwordResetToken
            });
            return React__default["default"].createElement(Component, Object.assign({
                resetPassword,
                customer: result,
                loading,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to place an order following [[`useCheckOut | checkout`]] and [[`useSetOrderDetails | setOrderDetails`]].
   * This concludes a check out process.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [placeOrder, result, loading, error] = usePlaceOrder({ orderId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle button click
   * const handleButtonClick = () => {
   *   placeOrder();
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `placeOrder`: A function to trigger the `placeOrder` mutation from your UI.
   *   The function returns a promise that fulfills with [[`PlaceOrder_placeOrder | PlaceOrderResponse`]].
   * - `result`: The [[`PlaceOrder_placeOrder | PlaceOrderResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Order
   */    function usePlaceOrder({orderId, orderNumber}) {
        const [mutate, {loading, data, error}] = client.useMutation(PLACE_ORDER, {
            variables: {
                id: orderId,
                orderNumber
            },
            refetchQueries: [ {
                query: FIND_ORDERS
            } ],
            awaitRefetchQueries: true
        });
        const placeOrder = () => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate();
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.placeOrder;
        }));
        return [ placeOrder, data === null || data === void 0 ? void 0 : data.placeOrder, loading, error ];
    }
    /**
   * React HOC to place an order following [[`withCheckOut | checkout`]] and [[`withSetOrderDetails | setOrderDetails`]].
   * This concludes a check out process.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "Place Order" button.
   * function PlaceOrderButton({ placeOrder, loading, result, error }: PlaceOrderProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     placeOrder();
   *   }
   *
   *   return (
   *     // renders the "Place Order" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedPlaceOrderButton = withPlaceOrder(PlaceOrderButton);
   *
   * // Use the enhanced component.
   * <EnhancedPlaceOrderButton orderId={orderId} />
   * ~~~
   *
   * @category Order
   */    function withPlaceOrder(Component) {
        return _a => {
            var {orderId, orderNumber} = _a, props = __rest(_a, [ "orderId", "orderNumber" ]);
            const [placeOrder, result, loading, error] = usePlaceOrder({
                orderId,
                orderNumber
            });
            return React__default["default"].createElement(Component, Object.assign({
                placeOrder,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to set details of an order following [[`useCheckOut | checkout`]].
   * *Note:* Depending on the commerce provider you use, all fields may not be supported.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [setOrderDetails, result, loading, error] = useSetOrderDetails({ orderId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   setOrderDetails({
   *     shippingAddressId,
   *     billingAddressId,
   *     shipmentMethodId,
   *     accountIssuer,
   *     accountNumber,
   *     accountHolderName,
   *     additionalCode,
   *     expirationMonth,
   *     expirationYear,
   *     email,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `setOrderDetails`: A function to trigger the `setOrderDetails` mutation from your UI.
   *   You can pass [[`SetOrderDetailsParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`SetOrderDetails_setOrderDetails | SetOrderDetailsResponse`]].
   * - `result`: The [[`SetOrderDetails_setOrderDetails | SetOrderDetailsResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Order
   */    function useSetOrderDetails({orderId}) {
        const [mutate, {loading, data, error}] = client.useMutation(SET_ORDER_DETAILS, {
            fetchPolicy: "no-cache",
            update(cache) {
                const result = cache.evict({
                    fieldName: "getOrderShipmentMethods",
                    args: {
                        id: orderId
                    }
                });
                if (result) {
                    cache.gc();
                }
            }
        });
        const setOrderDetails = ({shippingAddressId, billingAddressId, shipmentMethodId, accountIssuer, accountNumber, accountHolderName, additionalCode, expirationMonth, expirationYear, email}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            let paymentData;
            if (accountIssuer && accountNumber && accountHolderName) {
                paymentData = {
                    accountIssuer,
                    accountNumber,
                    accountHolderName,
                    additionalCode
                };
                if (expirationMonth && expirationYear) {
                    paymentData.accountExpirationDate = {
                        month: expirationMonth,
                        year: expirationYear
                    };
                }
            }
            const result = yield mutate({
                variables: {
                    input: {
                        id: orderId,
                        billingAddress: billingAddressId ? {
                            addressId: billingAddressId
                        } : undefined,
                        shipmentAddress: shippingAddressId ? {
                            addressId: shippingAddressId
                        } : undefined,
                        shipmentMethod: shipmentMethodId ? {
                            shipmentMethodId
                        } : undefined,
                        paymentMethod: paymentData ? {
                            paymentData
                        } : undefined,
                        email
                    }
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.setOrderDetails;
        }));
        return [ setOrderDetails, data === null || data === void 0 ? void 0 : data.setOrderDetails, loading, error ];
    }
    /**
   * React HOC to set details of an order following [[`withCheckOut | checkout`]].
   * *Note:* Depending on the commerce provider you use, all fields may not be supported.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "Check Out" form.
   * function CheckOutForm({ setOrderDetails, loading, result, error }: SetOrderDetailsProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     setOrderDetails({
   *       shippingAddressId,
   *       billingAddressId,
   *       shipmentMethodId,
   *       accountIssuer,
   *       accountNumber,
   *       accountHolderName,
   *       additionalCode,
   *       expirationMonth,
   *       expirationYear,
   *       email,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Check Out" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedCheckOutForm = withSetOrderDetails(CheckOutForm);
   *
   * // Use the enhanced component.
   * <EnhancedCheckOutForm orderId={orderId} />
   * ~~~
   *
   * @category Order
   */    function withSetOrderDetails(Component) {
        return _a => {
            var {orderId} = _a, props = __rest(_a, [ "orderId" ]);
            const [setOrderDetails, result, loading, error] = useSetOrderDetails({
                orderId
            });
            return React__default["default"].createElement(Component, Object.assign({
                setOrderDetails,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to fetch shipment methods for an order draft.
   * You can then use the result to set [[`SetOrderDetailsParams.shipmentMethodId | shipmentMethodId`]]
   * in [[`useSetOrderDetails`]].
   * *Note:* Depending on the commerce provider you use, this may not be supported.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [shipmentMethods, loading, error] = useShipmentMethods({ orderId });
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `shipmentMethods`:
   *   An array containing the [[`OrderShipmentMethods_getOrderShipmentMethods | OrderShipmentMethod`]] results.
   *   Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Order
   */    function useShipmentMethods({orderId, customQueryOptionsProcessor}) {
        var _a;
        const {loading, data, error} = useQueryCustom(GET_ORDER_SHIPMENT_METHODS, {
            variables: {
                id: orderId
            }
        }, customQueryOptionsProcessor);
        return [ (_a = data === null || data === void 0 ? void 0 : data.getOrderShipmentMethods) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC to fetch shipment methods for an order draft.
   * You can then use the result to set [[`SetOrderDetailsParams.shipmentMethodId | shipmentMethodId`]]
   * in [[`withSetOrderDetails`]].
   * *Note:* Depending on the commerce provider you use, this may not be supported.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a shipment methods selection.
   * function ShipmentMethods({ loading, shipmentMethods, error }: GetShipmentMethodsProps) {
   *   return (
   *     // renders shipment methods selection
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedShipmentMethods = withShipmentMethods(ShipmentMethods);
   *
   * // Use the enhanced component.
   * <EnhancedShipmentMethods orderId={orderId} />
   * ~~~
   *
   * @category Order
   */    function withShipmentMethods(Component) {
        return _a => {
            var {orderId} = _a, props = __rest(_a, [ "orderId" ]);
            const [result, loading, error] = useShipmentMethods({
                orderId
            });
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                shipmentMethods: result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to fetch orders for current customer.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [onLoadMore, ordersPageResult, loading, error] = useOrders({ pageSize, sortFields });
   *
   * // To fetch the next page
   * const handleLoadMore = () => {
   *   onLoadMore();
   * }
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `onLoadMore`: A function that enables pagination for your query.
   * - `ordersPageResult`: An object containing the [['Orders_findOrders | OrdersResponse']] result.
   *   Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Order
   */    function useOrders({pageSize, sortFields, customQueryOptionsProcessor}) {
        const {loading, data, fetchMore, error} = useQueryCustom(FIND_ORDERS, {
            variables: {
                sortFields,
                offset: 0,
                limit: pageSize
            }
        }, customQueryOptionsProcessor);
        if (!(data === null || data === void 0 ? void 0 : data.findOrders)) {
            return [ () => Promise.resolve(), undefined, loading, error ];
        }
        const {findOrders} = data;
        const {offset, count, queryHint} = findOrders;
        const onLoadMore = () => __awaiter(this, void 0, void 0, (function*() {
            const variables = (queryHint === null || queryHint === void 0 ? void 0 : queryHint.cursor) ? {
                queryHint: {
                    cursor: queryHint.cursor
                }
            } : {
                offset: offset + count
            };
            yield fetchMore({
                variables
            });
        }));
        return [ onLoadMore, findOrders, loading, error ];
    }
    /**
   * React HOC for fetching orders for current customer.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an order list.
   * function OrderList({ onLoadMore, loading, ordersPageResult, error }: OrdersProps) {
   *   // To fetch the next page
   *   const handleLoadMore = () => {
   *     onLoadMore();
   *   }
   *
   *   return (
   *     // renders order list
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedOrderList = withOrders(OrderList);
   *
   * // Use the enhanced component.
   * <EnhancedOrderList pageSize={pageSize} sortFields={sortFields} />
   * ~~~
   *
   * @category Order
   */    function withOrders(Component) {
        return _a => {
            var {pageSize, sortFields} = _a, props = __rest(_a, [ "pageSize", "sortFields" ]);
            const [onLoadMore, findOrders, loading, error] = useOrders({
                pageSize,
                sortFields
            });
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                ordersPageResult: findOrders,
                onLoadMore,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to fetch an order.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [order, loading, error] = useOrder({ orderId });
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `order`: An object containing the [[`OrderFragment`]] result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Order
   */    function useOrder({orderId, orderNumber, customQueryOptionsProcessor}) {
        const {loading, data, error} = useQueryCustom(orderNumber ? GET_ORDER_BY_ORDER_NUMBER : GET_ORDER_BY_ID, orderNumber ? {
            variables: {
                orderNumber
            }
        } : {
            variables: {
                id: orderId !== null && orderId !== void 0 ? orderId : ""
            }
        }, customQueryOptionsProcessor);
        let order;
        if (data) {
            order = "getOrderByOrderNumber" in data ? data.getOrderByOrderNumber : data.getOrderById;
        }
        return [ order !== null && order !== void 0 ? order : undefined, loading, error ];
    }
    /**
   * React HOC for fetching an order.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an order detail.
   * function OrderDetail({ loading, order, error }: OrderProps) {
   *   return (
   *     // renders order details
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedOrderDetail = withOrder(Order);
   *
   * // Use the enhanced component.
   * <EnhancedOrderDetail orderId={orderId} />
   * ~~~
   *
   * @category Order
   */    function withOrder(Component) {
        return _a => {
            var {orderId, orderNumber} = _a, props = __rest(_a, [ "orderId", "orderNumber" ]);
            const [result, loading, error] = useOrder({
                orderId,
                orderNumber
            });
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                order: result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to *replace* the customer's existing cart (or create a new cart if there isn't one)
   * with items from one of their existing orders ("re-order").
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [reOrder, result, loading, error] = useReOrder({ orderId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle button click
   * const handleButtonClick = () => {
   *   reOrder();
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `reOrder`: A function to trigger the `updateCartByOrder` mutation from your UI.
   *   The function returns a promise that fulfills with [[`UpdateCartByOrder_updateCartByOrder | ReOrderResponse`]].
   * - `cart`: The [[`UpdateCartByOrder_updateCartByOrder | ReOrderResponse`]] returned from your mutation.
   *   It represents the cart being replaced/created. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Order
   */    function useReOrder({orderId}) {
        const [mutate, {loading, data, error}] = client.useMutation(UPDATE_CART_BY_ORDER, {
            variables: {
                orderId
            }
        });
        const reOrder = () => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate();
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCartByOrder;
        }));
        return [ reOrder, data === null || data === void 0 ? void 0 : data.updateCartByOrder, loading, error ];
    }
    /**
   * React HOC to *replace* the customer's existing cart (or create a new cart if there isn't one)
   * with items from one of their existing orders ("re-order").
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a "Re Order" button.
   * function ReOrderButton({ reOrder, loading, result, error }: ReOrderProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     reOrder();
   *   }
   *
   *   return (
   *     // renders the "Re Order" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedReOrderButton = withReOrder(ReOrderButton);
   *
   * // Use the enhanced component.
   * <EnhancedReOrderButton orderId={orderId} />
   * ~~~
   *
   * @category Order
   */    function withReOrder(Component) {
        return _a => {
            var {orderId} = _a, props = __rest(_a, [ "orderId" ]);
            const [reOrder, result, loading, error] = useReOrder({
                orderId
            });
            return React__default["default"].createElement(Component, Object.assign({
                reOrder,
                loading,
                cart: result,
                error
            }, props));
        };
    }
    const CATEGORY_FRAGMENT = client.gql`
  fragment CategoryFragment on Category {
    id
    key
    parentId
    displayName
    path
    slug
    parent {
      id
      displayName
      path
      parentId
    }
  }
`;
    const FIND_CATEGORIES = client.gql`
  query Categories($queryHint: QueryHintInput) {
    findCategories(queryHint: $queryHint) {
      ...CategoryFragment
    }
  }

  ${CATEGORY_FRAGMENT}
`;
    const GET_CATEGORY_BY_ID = client.gql`
  query Category($id: String!, $queryHint: QueryHintInput) {
    findCategoryById(id: $id, queryHint: $queryHint) {
      ...CategoryFragment
    }
  }

  ${CATEGORY_FRAGMENT}
`;
    const GET_CATEGORY_BY_SLUG = client.gql`
  query CategoryBySlug($slug: String!, $queryHint: QueryHintInput) {
    findCategoryBySlug(slug: $slug, queryHint: $queryHint) {
      ...CategoryFragment
    }
  }

  ${CATEGORY_FRAGMENT}
`
    /**
   * Custom Hook for fetching categories.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [categories, loading, error] = useCategories({
   *   smViewId,
   *   connector,
   *   brUid2,
   * });
   * ~~~
   *
   * @param [[`CategoriesInputProps`]]
   * @returns An array constitutes of the following:
   * - `categories`: An array containing the [[`CategoryFragment`]]. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Category
   */;
    function useCategories({smViewId, connector, brUid2, smAccountId, smAuthKey, smDomainKey, storeKey, customQueryOptionsProcessor, brEnvType}) {
        var _a;
        const queryOptions = {
            variables: {
                queryHint: {
                    brUid2,
                    viewId: smViewId,
                    accountId: smAccountId,
                    authKey: smAuthKey,
                    domainKey: smDomainKey,
                    storeKey,
                    brEnvType
                }
            }
        };
        if (connector) {
            queryOptions.context = {
                headers: {
                    connector
                }
            };
        }
        const {loading, data, error} = useQueryCustom(FIND_CATEGORIES, queryOptions, customQueryOptionsProcessor);
        return [ (_a = data === null || data === void 0 ? void 0 : data.findCategories) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for fetching categories.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders categories.
   * function Categories({ loading, categories, error }: CategoriesProps) {
   *   return (
   *     // renders categories
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedCategories = withCategories(Categories);
   *
   * // Use the enhanced component.
   * <EnhancedCategories
   *   smViewId={smViewId}
   *   brUid2={cookies._br_uid_2}
   *   connector={connector}
   * />
   * ~~~
   *
   * @category Category
   */    function withCategories(Component) {
        return _a => {
            var {connector, smViewId, brUid2, smAccountId, smAuthKey, smDomainKey, storeKey, brEnvType} = _a, props = __rest(_a, [ "connector", "smViewId", "brUid2", "smAccountId", "smAuthKey", "smDomainKey", "storeKey", "brEnvType" ]);
            const [result, loading, error] = useCategories({
                connector,
                smViewId,
                brUid2,
                smAccountId,
                smAuthKey,
                smDomainKey,
                storeKey,
                brEnvType
            });
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                categories: result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook for fetching a category.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [category, loading, error] = useCategory({
   *   categoryId,
   *   smViewId,
   *   connector,
   *   brUid2: cookies._br_uid_2,
   * });
   * ~~~
   *
   * @param [[`CategoryInputProps`]]
   * @returns An array constitutes of the following:
   * - `category`: An object containing the [[CategoryFragment | category]] result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Category
   */    function useCategory({categoryId, slug, smViewId, connector, brUid2, smAccountId, smAuthKey, smDomainKey, storeKey, customQueryOptionsProcessor, brEnvType}) {
        let queryOptions = {};
        if (connector) {
            queryOptions.context = {
                headers: {
                    connector
                }
            };
        }
        const queryHint = {
            brUid2,
            viewId: smViewId,
            accountId: smAccountId,
            authKey: smAuthKey,
            domainKey: smDomainKey,
            storeKey,
            brEnvType
        };
        if (slug) {
            queryOptions = Object.assign(Object.assign({}, queryOptions), {
                variables: {
                    slug,
                    queryHint
                }
            });
        } else {
            queryOptions = Object.assign(Object.assign({}, queryOptions), {
                variables: {
                    id: categoryId,
                    queryHint
                }
            });
        }
        const {loading, data, error} = useQueryCustom(slug ? GET_CATEGORY_BY_SLUG : GET_CATEGORY_BY_ID, queryOptions, customQueryOptionsProcessor);
        const resultData = data !== null && data !== void 0 ? data : {};
        const category = "findCategoryBySlug" in resultData ? resultData.findCategoryBySlug : resultData.findCategoryById;
        return [ category !== null && category !== void 0 ? category : undefined, loading, error ];
    }
    /**
   * React HOC for fetching a category.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a category.
   * function Category({ category, loading, error }: CategoryProps) {
   *   return (
   *     // renders a category
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedCategory = withCategory(Category);
   *
   * // Use the enhanced component.
   * <EnhancedCategory
   *   categoryId={categoryId}
   *   connector={connector}
   *   smViewId={smViewId}
   *   brUid2={cookies._br_uid_2}
   * />
   * ~~~
   *
   * @category Category
   */    function withCategory(Component) {
        return _a => {
            var {categoryId, connector, smViewId, brUid2, smAccountId, smAuthKey, smDomainKey, storeKey, brEnvType} = _a, props = __rest(_a, [ "categoryId", "connector", "smViewId", "brUid2", "smAccountId", "smAuthKey", "smDomainKey", "storeKey", "brEnvType" ]);
            const [result, loading, error] = useCategory({
                categoryId,
                connector,
                smViewId,
                brUid2,
                smAccountId,
                smAuthKey,
                smDomainKey,
                storeKey,
                brEnvType
            });
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                category: result,
                error
            }, props));
        };
    }
    const WISHLIST_FRAGMENT = client.gql`
  fragment WishlistFragment on Wishlist {
    id
    key
    name
    description
    entries {
      id
      quantity
      customAttrs {
        name
        values
      }
      items {
        ... on Item {
          ...ItemFragment
        }
        ... on ItemVariant {
          ...ItemVariantFragment
        }
      }
    }
  }

  ${ITEM_FRAGMENT}
  ${ITEM_VARIANT_FRAGMENT}
  ${MONEY_AMOUNT_FRAGMENT}
`;
    const ADD_ENTRY_TO_WISHLIST = client.gql`
  mutation AddEntryToWishlist($input: AddEntryToWishlistInput!) {
    addEntryToWishlist(addEntryToWishlistInput: $input) {
      code
      success
      message
      wishlist {
        ...WishlistFragment
      }
    }
  }

  ${WISHLIST_FRAGMENT}
`;
    const UPDATE_WISHLIST_ENTRY = client.gql`
  mutation UpdateWishlistEntry($input: UpdateWishlistEntryInput!) {
    updateWishlistEntry(updateWishlistEntryInput: $input) {
      code
      success
      message
      wishlist {
        ...WishlistFragment
      }
    }
  }

  ${WISHLIST_FRAGMENT}
`;
    const REMOVE_ENTRY_FROM_WISHLIST = client.gql`
  mutation RemoveEntryFromWishlist($input: RemoveEntryFromWishlistInput!) {
    removeEntryFromWishlist(removeEntryFromWishlistInput: $input) {
      code
      success
      message
      wishlist {
        ...WishlistFragment
      }
    }
  }

  ${WISHLIST_FRAGMENT}
`;
    client.gql`
  mutation CreateWishlist($input: CreateWishlistInput!) {
    createWishlist(createWishlistInput: $input) {
      code
      success
      message
      wishlist {
        ...WishlistFragment
      }
    }
  }

  ${WISHLIST_FRAGMENT}
`;
    const UPDATE_WISHLIST = client.gql`
  mutation UpdateWishlist($input: UpdateWishlistInput!) {
    updateWishlist(updateWishlistInput: $input) {
      code
      success
      message
      wishlist {
        ...WishlistFragment
      }
    }
  }

  ${WISHLIST_FRAGMENT}
`;
    const REMOVE_WISHLIST = client.gql`
  mutation RemoveWishlist($wishlistId: String!) {
    removeWishlist(wishlistId: $wishlistId) {
      code
      success
      message
      wishlist {
        ...WishlistFragment
      }
    }
  }

  ${WISHLIST_FRAGMENT}
`;
    const FIND_WISHLISTS = client.gql`
  query Wishlists($offset: Int, $limit: Int, $queryHint: QueryHintInput) {
    findWishlists(offset: $offset, limit: $limit, queryHint: $queryHint) {
      offset
      limit
      count
      total
      wishlists {
        id
        key
        name
        description
      }
      queryHint {
        cursor
      }
    }
  }
`;
    const FIND_WISHLIST_BY_ID = client.gql`
  query Wishlist($id: String) {
    findWishlistById(id: $id) {
      ...WishlistFragment
    }
  }

  ${WISHLIST_FRAGMENT}
`
    /**
   * Custom Hook for fetching a wishlist.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [wishlist, loading, error] = useWishlist({ wishlistId });
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `wishlist`: An object containing the [[`WishlistFragment`]] result. Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Wishlist
   */;
    function useWishlist({wishlistId, customQueryOptionsProcessor}) {
        var _a;
        const queryOptions = {
            variables: {
                id: wishlistId
            }
        };
        const {loading, data, error} = useQueryCustom(FIND_WISHLIST_BY_ID, queryOptions, customQueryOptionsProcessor);
        return [ (_a = data === null || data === void 0 ? void 0 : data.findWishlistById) !== null && _a !== void 0 ? _a : undefined, loading, error ];
    }
    /**
   * React HOC for fetching a wishlist.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders a wishlist.
   * function Wishlist({ loading, wishlist, error }: WishlistProps) {
   *   return (
   *     // renders a wishlist
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedWishlist = useWishlist(Wishlist);
   *
   * // Use the enhanced component.
   * <EnhancedWishlist wishlistId={wishlistId} />
   * ~~~
   *
   * @category Wishlist
   */    function withWishlist(Component) {
        return _a => {
            var {wishlistId} = _a, props = __rest(_a, [ "wishlistId" ]);
            const [result, loading, error] = useWishlist({
                wishlistId
            });
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                wishlist: result,
                error
            }, props));
        };
    }
    const DEFAULT_OFFSET = 0;
    const DEFAULT_WISHLISTS_PAGE_SIZE = 100;
    /**
   * Custom Hook to fetch wishlists for current customer.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [onLoadMore, wishlistsResult, loading, error] = useWishlists();
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `wishlistsResult`: An object containing the [['Wishlists_findWishlists | WishlistsResponse']] result.
   *   Defaults to undefined.
   * - `loading`: A boolean that indicates whether the request is in flight.
   * - `error`: A runtime error with graphQLErrors and networkError properties.
   *
   * @category Wishlist
   */    function useWishlists({offset: start = DEFAULT_OFFSET, pageSize = DEFAULT_WISHLISTS_PAGE_SIZE, customQueryOptionsProcessor}) {
        const continuousLoadRef = React.useRef(false);
        const {loading, data, fetchMore, error} = useQueryCustom(FIND_WISHLISTS, {
            variables: {
                offset: start !== null && start !== void 0 ? start : 0,
                limit: pageSize
            }
        }, customQueryOptionsProcessor);
        if (!(data === null || data === void 0 ? void 0 : data.findWishlists)) {
            return [ () => Promise.resolve(), undefined, loading, error ];
        }
        const {findWishlists} = data;
        const {offset, count} = findWishlists;
        const onLoadMore = offsetParam => __awaiter(this, void 0, void 0, (function*() {
            const variables = {
                offset: offsetParam !== null && offsetParam !== void 0 ? offsetParam : offset + count
            };
            continuousLoadRef.current = offsetParam == null;
            yield fetchMore({
                variables
            });
        }));
        let result = findWishlists;
        if (!continuousLoadRef.current) {
            result = getPaginatedWishlists(findWishlists);
        }
        return [ onLoadMore, result, loading, error ];
    }
    /**
   * React HOC for fetching wishlists for current customer.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an order list.
   * function Wishlists({ loading, wishlistsResult, error }: WishlistsProps) {
   *   return (
   *     // renders wishlists
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedWishlists = withWishlists(Wishlists);
   *
   * // Use the enhanced component.
   * <EnhancedWishlists />
   * ~~~
   *
   * @category Wishlist
   */    function withWishlists(Component) {
        return _a => {
            var {pageSize} = _a, props = __rest(_a, [ "pageSize" ]);
            const [onLoadMore, findWishlists, loading, error] = useWishlists({
                pageSize
            });
            return React__default["default"].createElement(Component, Object.assign({
                loading,
                wishlistsPageResult: findWishlists,
                onLoadMore,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to update a wishlist entry.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [updateWishlistEntry, result, loading, error] = useUpdateWishlistEntry({ wishlistId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   updateWishlistEntry({
   *     entryId,
   *     quantity,
   *     customAttrs,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `updateWishlistEntry`: A function to trigger the `updateWishlistEntry` mutation from your UI.
   *   You can pass [[`UpdateWishlistEntryParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`UpdateWishlistEntry_updateWishlistEntry | UpdateWishlistEntryResponse`]].
   * - `result`: The [[`UpdateWishlistEntry_updateWishlistEntry | UpdateWishlistEntryResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Wishlist
   */    function useUpdateWishlistEntry({wishlistId}) {
        const [error, setError] = React.useState();
        const [mutate, {data, loading}] = client.useMutation(UPDATE_WISHLIST_ENTRY);
        const updateWishlistEntry = ({entryId, quantity, customAttrs}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            if (!quantity && !customAttrs) {
                setError(new client.ApolloError({
                    errorMessage: "Must provide at least one of the parameters: quantity, customAttrs"
                }));
                return;
            }
            const result = yield mutate({
                variables: {
                    input: {
                        wishlistId,
                        entryId,
                        quantity,
                        customAttrs
                    }
                }
            });
            if (result.errors && result.errors.length > 0) {
                setError(new client.ApolloError({
                    graphQLErrors: result.errors
                }));
            } else {
                setError(undefined);
            }
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateWishlistEntry;
        }));
        return [ updateWishlistEntry, data === null || data === void 0 ? void 0 : data.updateWishlistEntry, loading, error ];
    }
    /**
   * React HOC for updating a wishlist entry.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Update Wishlist Entry" form.
   * function UpdateWishlistEntryForm({ updateWishlistEntry, loading, result, error }: UpdateWishlistEntryProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     updateWishlistEntry({
   *       entryId,
   *       quantity,
   *       customAttrs,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Update Wishlist Entry" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedUpdateWishlistEntryForm = withUpdateWishlistEntry(UpdateWishlistEntryForm);
   *
   * // Use the enhanced component.
   * <EnhancedUpdateWishlistEntryForm wishlistId={wishlistId} />
   * ~~~
   *
   * @category Wishlist
   */    function withUpdateWishlistEntry(Component) {
        return _a => {
            var {wishlistId} = _a, props = __rest(_a, [ "wishlistId" ]);
            const [updateWishlistEntry, result, loading, error] = useUpdateWishlistEntry({
                wishlistId
            });
            return React__default["default"].createElement(Component, Object.assign({
                updateWishlistEntry,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to remove an entry from wishlist.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [removeEntryFromWishlist, result, loading, error] = useRemoveEntryFromWishlist({ wishlistId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle "Remove From Wishlist" button click
   * const handleButtonClick = () => {
   *   removeEntryFromWishlist({ entryId });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `removeEntryFromWishlist`: A function to trigger the `removeEntryFromWishlist` mutation from your UI.
   *   You can pass [[`RemoveEntryFromWishlistParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`RemoveEntryFromWishlist_removeEntryFromWishlist | RemoveEntryFromWishlistResponse`]].
   * - `result`: The [[`RemoveEntryFromWishlist_removeEntryFromWishlist | RemoveEntryFromWishlistResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Wishlist
   */    function useRemoveEntryFromWishlist({wishlistId}) {
        const [mutate, {data, loading, error}] = client.useMutation(REMOVE_ENTRY_FROM_WISHLIST);
        const removeEntryFromWishlist = ({entryId}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    input: {
                        wishlistId,
                        entryId
                    }
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.removeEntryFromWishlist;
        }));
        return [ removeEntryFromWishlist, data === null || data === void 0 ? void 0 : data.removeEntryFromWishlist, loading, error ];
    }
    /**
   * React HOC for removing an entry from wishlist.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Remove From Wishlist" button.
   * function RemoveEntryFromWishlistButton({
   *   removeEntryFromWishlist,
   *   loading,
   *   result,
   *   error,
   * }: RemoveEntryFromWishlistProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     removeEntryFromWishlist({ entryId });
   *   }
   *
   *   return (
   *     // renders the "Remove From Wishlist" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedRemoveEntryFromWishlistButton = withRemoveEntryFromWishlist(RemoveEntryFromWishlistButton);
   *
   * // Use the enhanced component.
   * <EnhancedRemoveEntryFromWishlistButton wishlistId={wishlistId} />
   * ~~~
   *
   * @category Wishlist
   */    function withRemoveEntryFromWishlist(Component) {
        return _a => {
            var {wishlistId} = _a, props = __rest(_a, [ "wishlistId" ]);
            const [removeEntryFromWishlist, result, loading, error] = useRemoveEntryFromWishlist({
                wishlistId
            });
            return React__default["default"].createElement(Component, Object.assign({
                removeEntryFromWishlist,
                loading,
                result,
                error
            }, props));
        };
    }
    /**
   * Custom Hook to update a wishlist.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [updateWishlist, result, loading, error] = useUpdateWishlist();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle form submission
   * const handleFormSubmit = () => {
   *   updateWishlist({
   *     wishlistId,
   *     name,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `updateWishlist`: A function to trigger the `updateWishlist` mutation from your UI.
   *   You can pass [[`UpdateWishlistParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`UpdateWishlist_updateWishlist | UpdateWishlistResponse`]].
   * - `result`: The [[`UpdateWishlist_updateWishlist | UpdateWishlistResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Wishlist
   */    function useUpdateWishlist() {
        const [error, setError] = React.useState();
        const [mutate, {data, loading}] = client.useMutation(UPDATE_WISHLIST);
        const updateWishlist = ({wishlistId, name, description}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            if (!wishlistId || !name) {
                setError(new client.ApolloError({
                    errorMessage: "Must provide the parameters: wishlistId, name"
                }));
                return;
            }
            const result = yield mutate({
                variables: {
                    input: {
                        wishlistId,
                        name,
                        description
                    }
                }
            });
            if (result.errors && result.errors.length > 0) {
                setError(new client.ApolloError({
                    graphQLErrors: result.errors
                }));
            } else {
                setError(undefined);
            }
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateWishlist;
        }));
        return [ updateWishlist, data === null || data === void 0 ? void 0 : data.updateWishlist, loading, error ];
    }
    /**
   * React HOC for updating a wishlist.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Update Wishlist" form.
   * function UpdateWishlistForm({ updateWishlist, loading, result, error }: UpdateWishlistProps) {
   *
   *   // A sample event handler to handle form submission
   *   const handleFormSubmit = () => {
   *     updateWishlist({
   *       wishlistId,
   *       name,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Update Wishlist" form
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedUpdateWishlistForm = withUpdateWishlist(UpdateWishlistForm);
   *
   * // Use the enhanced component.
   * <EnhancedUpdateWishlistForm />
   * ~~~
   *
   * @category Wishlist
   */    function withUpdateWishlist(Component) {
        return () => {
            const [updateWishlist, result, loading, error] = useUpdateWishlist();
            return React__default["default"].createElement(Component, Object.assign({
                updateWishlist,
                loading,
                result,
                error
            }, {}));
        };
    }
    /**
   * Custom Hook to remove a wishlist.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [removeWishlist, result, loading, error] = useRemoveWishlist({ wishlistId });
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle "Remove From Wishlist" button click
   * const handleButtonClick = () => {
   *   removeWishlist({ wishlistId });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `removeWishlist`: A function to trigger the `removeWishlist` mutation from your UI.
   *   You can pass [[`RemoveWishlistParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`RemoveWishlist_removeWishlist | RemoveWishlistResponse`]].
   * - `result`: The [[`RemoveWishlist_removeWishlist | RemoveWishlistResponse`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Wishlist
   */    function useRemoveWishlist() {
        const [mutate, {data, loading, error}] = client.useMutation(REMOVE_WISHLIST, {
            update(cache) {
                cache.evict({
                    id: "ROOT_QUERY",
                    fieldName: "findWishlists"
                });
            }
        });
        const removeWishlist = ({wishlistId}) => __awaiter(this, void 0, void 0, (function*() {
            var _a;
            const result = yield mutate({
                variables: {
                    wishlistId
                }
            });
            return (_a = result.data) === null || _a === void 0 ? void 0 : _a.removeWishlist;
        }));
        return [ removeWishlist, data === null || data === void 0 ? void 0 : data.removeWishlist, loading, error ];
    }
    /**
   * React HOC for removing a  wishlist.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Remove Wishlist" button.
   * function RemoveWishlistButton({
   *   removeWishlist,
   *   loading,
   *   result,
   *   error,
   * }: RemoveWishlistProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     removeWishlist({ wishlistId });
   *   }
   *
   *   return (
   *     // renders the "Remove Wishlist" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedRemoveWishlistButton = withRemoveWishlist(RemoveWishlistButton);
   *
   * // Use the enhanced component.
   * <EnhancedRemoveWishlistButton wishlistId={wishlistId} />
   * ~~~
   *
   * @category Wishlist
   */    function withRemoveWishlist(Component) {
        return () => {
            const [removeWishlist, result, loading, error] = useRemoveWishlist();
            return React__default["default"].createElement(Component, Object.assign({
                removeWishlist,
                loading,
                result,
                error
            }, {}));
        };
    }
    /**
   * Custom Hook to add an item to the wishlist.
   *
   * ~~~typescript
   * // An exmple usage with the hook.
   * const [addEntryToWishlist, result, loading, error] = useEntryAddToWishlist();
   * // ...
   * // Additional code
   * // ...
   * // A sample event handler to handle "Add To Wishlist" button click
   * const handleButtonClick = () => {
   *   addEntryToWishlist({
   *     wishlistId,
   *     itemId,
   *     quantity,
   *     customAttrs,
   *   });
   * }
   *
   * ~~~
   *
   * @returns An array constitutes of the following:
   * - `addEntryToWishlist`: A function to trigger the `addEntryToWishlist` mutation from your UI.
   *   You can pass [[`AddEntryToWishlistParams`]] as parameters.
   *   The function returns a promise that fulfills with
   *   [[`AddEntryToWishlist_addEntryToWishlist | AddEntryToWishlistResult`]].
   * - `result`: The [[`AddEntryToWishlist_addEntryToWishlist | AddEntryToWishlistResult`]]
   *   returned from your mutation. Defaults to undefined.
   * - `loading`: A boolean that indicates whether your mutation is in flight.
   * - `error`: Any errors returned from the mutation.
   *
   * @category Wishlist
   */    function useAddEntryToWishlist() {
        const [mutate, {data, loading, error}] = client.useMutation(ADD_ENTRY_TO_WISHLIST, {
            update(cache) {
                cache.evict({
                    id: "ROOT_QUERY",
                    fieldName: "findWishlists"
                });
            }
        });
        const addEntryToWishlist = params => __awaiter(this, void 0, void 0, (function*() {
            var _a, _b, _c;
            const {wishlistId, quantity, itemId, customAttrs, newWishlistName, newWishlistDescription} = params;
            if (!wishlistId && !newWishlistName) {
                return undefined;
            }
            const result = yield mutate({
                variables: {
                    input: {
                        wishlistId: wishlistId !== null && wishlistId !== void 0 ? wishlistId : "",
                        quantity,
                        itemId: `${(_a = itemId.id) !== null && _a !== void 0 ? _a : ""}___${(_b = itemId.code) !== null && _b !== void 0 ? _b : ""}`,
                        customAttrs,
                        newWishlistName,
                        newWishlistDescription
                    }
                }
            });
            return (_c = result.data) === null || _c === void 0 ? void 0 : _c.addEntryToWishlist;
        }));
        return [ addEntryToWishlist, data === null || data === void 0 ? void 0 : data.addEntryToWishlist, loading, error ];
    }
    /**
   * React HOC for adding an item to wishlist.
   * Example usage:
   *
   * ~~~typescript
   * // Existing react component that renders an "Add To Wishlist" button.
   * function AddEntryToWishlistButton({ addEntryToWishlist, loading, result, error }: AddEntryToWishlistProps) {
   *
   *   // A sample event handler to handle button click
   *   const handleButtonClick = () => {
   *     addEntryToWishlist({
   *       wishlistId,
   *       itemId,
   *       quantity,
   *       customAttrs,
   *     });
   *   }
   *
   *   return (
   *     // renders the "Add To Wishlist" button
   *   );
   * }
   *
   * // Enhance the component.
   * const EnhancedAddEntryToWishlistButton = withAddEntryToWishlist(AddEntryToWishlistButton);
   *
   * // Use the enhanced component.
   * <EnhancedAddEntryToWishlistButton />
   * ~~~
   *
   * @category Wishlist
   */    function withAddEntryToWishlist(Component) {
        return () => {
            const [addToWishlist, result, loading, error] = useAddEntryToWishlist();
            return React__default["default"].createElement(Component, Object.assign({
                addToWishlist,
                loading,
                result,
                error
            }, {}));
        };
    }
    (function(DiscountType) {
        DiscountType["Cart"] = "Cart";
        DiscountType["Product"] = "Product";
        DiscountType["Promotion"] = "Promotion";
    })(exports.DiscountType || (exports.DiscountType = {}));
    exports.CommerceApiClientFactory = CommerceApiClientFactory;
    exports.CommerceConnectorConsumer = CommerceConnectorConsumer;
    exports.CommerceConnectorContext = CommerceConnectorContext;
    exports.CommerceConnectorProvider = CommerceConnectorProvider;
    exports.auth = auth;
    exports.extractErrorMessage = extractErrorMessage;
    exports.loggedInVar = loggedInVar;
    exports.tokenVar = tokenVar;
    exports.useAddAddress = useAddAddress;
    exports.useAddEntryToWishlist = useAddEntryToWishlist;
    exports.useAddToCart = useAddToCart;
    exports.useAddressGroup = useAddressGroup;
    exports.useApplyCartDiscount = useApplyCartDiscount;
    exports.useCart = useCart;
    exports.useCategories = useCategories;
    exports.useCategory = useCategory;
    exports.useChangePassword = useChangePassword;
    exports.useCheckOut = useCheckOut;
    exports.useCreateCart = useCreateCart;
    exports.useCurrentCustomer = useCurrentCustomer;
    exports.useFederatedCheckOut = useFederatedCheckOut;
    exports.useFederatedLogin = useFederatedLogin;
    exports.useForgotPassword = useForgotPassword;
    exports.useLogin = useLogin;
    exports.useLogout = useLogout;
    exports.useOrder = useOrder;
    exports.useOrders = useOrders;
    exports.usePlaceOrder = usePlaceOrder;
    exports.useProductDetail = useProductDetail;
    exports.useProductGridCategory = useProductGridCategory;
    exports.useProductGridSearch = useProductGridSearch;
    exports.useProductGridWidget = useProductGridWidget;
    exports.useProductSearchSuggestion = useProductSearchSuggestion;
    exports.useQueryCustom = useQueryCustom;
    exports.useReOrder = useReOrder;
    exports.useRemoveAddress = useRemoveAddress;
    exports.useRemoveCart = useRemoveCart;
    exports.useRemoveCartDiscount = useRemoveCartDiscount;
    exports.useRemoveEntryFromWishlist = useRemoveEntryFromWishlist;
    exports.useRemoveFromCart = useRemoveFromCart;
    exports.useRemoveWishlist = useRemoveWishlist;
    exports.useResetPassword = useResetPassword;
    exports.useSetDefaultBillingAddress = useSetDefaultBillingAddress;
    exports.useSetDefaultShippingAddress = useSetDefaultShippingAddress;
    exports.useSetOrderDetails = useSetOrderDetails;
    exports.useShipmentMethods = useShipmentMethods;
    exports.useSignup = useSignup;
    exports.useUpdateAddress = useUpdateAddress;
    exports.useUpdateCartItem = useUpdateCartItem;
    exports.useUpdateCustomer = useUpdateCustomer;
    exports.useUpdateWishlist = useUpdateWishlist;
    exports.useUpdateWishlistEntry = useUpdateWishlistEntry;
    exports.useWishlist = useWishlist;
    exports.useWishlists = useWishlists;
    exports.withAddAddress = withAddAddress;
    exports.withAddEntryToWishlist = withAddEntryToWishlist;
    exports.withAddToCart = withAddToCart;
    exports.withAddressGroup = withAddressGroup;
    exports.withApplyCartDiscount = withApplyCartDiscount;
    exports.withCart = withCart;
    exports.withCategories = withCategories;
    exports.withCategory = withCategory;
    exports.withChangePassword = withChangePassword;
    exports.withCheckOut = withCheckOut;
    exports.withCreateCart = withCreateCart;
    exports.withCurrentCustomer = withCurrentCustomer;
    exports.withFederatedCheckOut = withFederatedCheckOut;
    exports.withFederatedLogin = withFederatedLogin;
    exports.withForgotPassword = withForgotPassword;
    exports.withLogin = withLogin;
    exports.withLogout = withLogout;
    exports.withOrder = withOrder;
    exports.withOrders = withOrders;
    exports.withPlaceOrder = withPlaceOrder;
    exports.withProductDetail = withProductDetail;
    exports.withProductGridCategory = withProductGridCategory;
    exports.withProductGridSearch = withProductGridSearch;
    exports.withProductGridWidget = withProductGridWidget;
    exports.withProductSearchSuggestion = withProductSearchSuggestion;
    exports.withReOrder = withReOrder;
    exports.withRemoveAddress = withRemoveAddress;
    exports.withRemoveCart = withRemoveCart;
    exports.withRemoveCartDiscount = withRemoveCartDiscount;
    exports.withRemoveEntryFromWishlist = withRemoveEntryFromWishlist;
    exports.withRemoveFromCart = withRemoveFromCart;
    exports.withRemoveWishlist = withRemoveWishlist;
    exports.withResetPassword = withResetPassword;
    exports.withSetDefaultBillingAddress = withSetDefaultBillingAddress;
    exports.withSetDefaultShippingAddress = withSetDefaultShippingAddress;
    exports.withSetOrderDetails = withSetOrderDetails;
    exports.withShipmentMethods = withShipmentMethods;
    exports.withSignup = withSignup;
    exports.withUpdateAddress = withUpdateAddress;
    exports.withUpdateCartItem = withUpdateCartItem;
    exports.withUpdateCustomer = withUpdateCustomer;
    exports.withUpdateWishlist = withUpdateWishlist;
    exports.withUpdateWishlistEntry = withUpdateWishlistEntry;
    exports.withWishlist = withWishlist;
    exports.withWishlists = withWishlists;
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
}));
//# sourceMappingURL=index.js.map
